<template>
    <div>
        <h2>Emissão de Nota Fiscal</h2>

        <v-row class="mb-2 totalizadores-linha" dense>
            <v-col
                v-for="card in totalizadores"
                :key="card.titulo"
                cols="12"
                sm="6"
                lg="3"
            >
                <v-card :class="['totalizador-card', card.classe]" outlined>
                    <div class="totalizador-card__titulo">{{ card.titulo }}</div>
                    <div class="totalizador-card__valor">{{ card.valor }}</div>
                </v-card>
            </v-col>
        </v-row>

        <div class="d-flex w-100 gap-10 search-form">
            <div class="w-100 flex-grow-1 d-flex align-center flex-wrap filtros-linha">
                <v-autocomplete
                    v-model="filtroTipoNf"
                    :items="getOpcoesTipoNf()"
                    item-text="text"
                    item-value="value"
                    dense
                    outlined
                    clearable
                    hide-details
                    label="Tipo da NF"
                    class="filtro-item"
                    @change="handleFiltroChange"
                    @click:clear="handleFiltroChange"
                />

                <v-autocomplete
                    v-model="filtroStatusNf"
                    :items="getOpcoesStatusNf()"
                    item-text="text"
                    item-value="value"
                    dense
                    outlined
                    clearable
                    hide-details
                    label="Status"
                    class="filtro-item"
                    @change="handleFiltroChange"
                    @click:clear="handleFiltroChange"
                />

                <v-autocomplete
                    v-model="filtroNumeroNf"
                    :items="getOpcoesNumeroNf()"
                    item-text="text"
                    item-value="value"
                    dense
                    outlined
                    clearable
                    hide-details
                    label="Numero da NF"
                    class="filtro-item"
                    @change="handleFiltroChange"
                    @click:clear="handleFiltroChange"
                />

                <v-autocomplete
                    v-model="filtroJobNumero"
                    :items="getOpcoesJobNumero()"
                    item-text="text"
                    item-value="value"
                    dense
                    outlined
                    clearable
                    hide-details
                    label="JOB"
                    class="filtro-item"
                    @change="handleFiltroChange"
                    @click:clear="handleFiltroChange"
                />

                <v-autocomplete
                    v-model="filtroDestinatario"
                    :items="getOpcoesDestinatario()"
                    item-text="text"
                    item-value="value"
                    dense
                    outlined
                    clearable
                    hide-details
                    label="Destinatário"
                    class="filtro-item"
                    @change="handleFiltroChange"
                    @click:clear="handleFiltroChange"
                />
            </div>
            
            <v-menu>
                <template v-slot:activator="{ on }">
                    <v-btn
                        color="primary"
                        v-on="on" 
                        large
                        icon
                    >
                        <v-icon>
                            mdi-plus
                        </v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item
                        v-for="(item, index) in optionTypeNf"
                        :key="index"
                        :value="index"
                        class="cursor-pointer"
                        @click="$router.push({ name: 'CreateIssuance', params: { typeNf: item } })"
                    >
                        <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item>
                </v-list>

            </v-menu>

            <!-- <div class="text-center">
                <v-menu>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="primary"
                            v-on="on" 
                            large
                            icon
                            @click="createValue"
                        >
                            <v-icon>
                                mdi-plus
                            </v-icon>
                        </v-btn>
                    </template>

                </v-menu>
            </div> -->
        </div>
        
        <v-data-table
            :headers="headers"
            :items="itemsData"
            class="elevation-1"
            disable-sort
            hide-default-footer
            :page.sync="page"      
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
        >
            <template  v-slot:[`item.tipoNotaFiscal`]="{ item }">
                <span>
                    {{ getTipoNotaFiscalLabel(item) }}
                </span>
            </template>

            <template v-slot:[`item.statusNf`]="{ item }">
                <v-chip :color="getColorBadge(item.statusNf).color" dark>
                    <span style="font-size: 12px;">
                        {{ item.statusNf == "Denegada" ? "Cancelada" : item.statusNf }} 
                    </span>
                    <v-icon small class="ml-2 text-start">{{ getColorBadge(item.statusNf).icon }}</v-icon>
                </v-chip>
            </template>

            <template v-slot:[`item.chaveAcesso`]="{ item }">
                <span>
                    {{ item.chaveAcesso ||'Não Informado' }}
                </span>
            </template>

            <template v-slot:[`item.numeroNf`]="{ item }">
                <span>
                    {{ getNumeroNf(item) }}
                </span>
            </template>

            <template v-slot:[`item.jobNumero`]="{ item }">
                <span>
                    {{ getJobNumero(item) }}
                </span>
            </template>

            <template  v-slot:[`item.displayValueNf`]="{ item }">
                <span>
                    {{ formatCurrency(item.displayValueNf ?? item.valueNf) }}
                </span>
            </template>

            <template  v-slot:[`item.destinatario`]="{ item }">
                <span>
                    {{ getDestinatarioNome(item) }}
                </span>
            </template>

            <template v-slot:[`item.createAt`]="{ item }">
                <span>
                    {{  new Date(item.createAt).toLocaleDateString() }}
                </span>
            </template>

            <template v-slot:[`item.actions`]="{ item }">

                <v-menu
                    bottom
                    left
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            dark
                            icon
                            v-bind="attrs"
                            v-on="on"
                            color="black"
                        >
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    
                    <v-list>

                        <v-list-item
                            v-if="!isStatusBloqueadoEdicao(item?.statusNf)"
                            style="cursor: pointer"
                            @click="editValue(item)">
                            <v-list-item-title>
                                <span>
                                    Editar
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item style="cursor: pointer" @click="duplicateValue(item)">
                            <v-list-item-title>
                                <span>
                                    Duplicar Nota Fiscal
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="isStatusPendente(item?.statusNf)"
                            style="cursor: pointer"
                            @click="abrirConfirmacaoExclusao(item)">
                            <v-list-item-title>
                                <span>
                                    Excluir Nota Fiscal
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item 
                           
                            style="cursor: pointer" @click="previeNf(item)">
                            <v-list-item-title>
                                <span>
                                    Pré-Visualização
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item 
                            v-if="item.tipoNotaFiscal !== 'Nota_Fiscal_de_Serviço' && item.statusNf !== 'Emitida' && !isStatusCancelada(item?.statusNf) && !isStatusProcessando(item?.statusNf)"
                            style="cursor: pointer" @click="emitirNotaFiscal(item)">
                            <v-list-item-title>
                                <span>
                                    Emitir Nota Fiscal
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                        v-if="item.tipoNotaFiscal === 'Nota_Fiscal_de_Serviço' && item.statusNf !== 'Emitida' && !isStatusCancelada(item?.statusNf) && !isStatusProcessando(item?.statusNf)"
                        style="cursor: pointer" @click="emitirNotaFiscalServico(item)">
                            <v-list-item-title>
                                <span>
                                    Emitir Nota Fiscal de serviço
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                        v-if="item.statusNf === 'Emitida'"
                        style="cursor: pointer" @click="handleAlertCancel(item)">
                            <v-list-item-title>
                                <span>
                                   Cancelar Nota Fiscal
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                        v-if="isStatusConsultavel(item?.statusNf)"
                        style="cursor: pointer" @click="item.tipoNotaFiscal !== 'Nota_Fiscal_de_Serviço' ? resumoNotaFiscal(item) : resumoNotaFiscalServico(item)">
                            <v-list-item-title>
                                <span>
                                    Consultar Nota Fiscal
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                        v-if="item.statusNf === 'Emitida'"
                        style="cursor: pointer" @click="geratedPdf(item)">
                            <v-list-item-title>
                                <span>
                                    Gerar PDF da Nota Fiscal
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                        v-if="item.statusNf === 'Emitida'"
                        style="cursor: pointer" @click="geratedXml(item)">
                            <v-list-item-title>
                                <span>
                                    Gerar XML da Nota Fiscal
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
        
        <div class="text-center pt-2">
            <v-pagination
                v-model="page"
                :length="pageCount"
                @input="pagination"
            ></v-pagination>
        </div>-


        <!-- <CreateIssuanceInvoiceView 
            :item="itemNf"
            :open="openCreateIssuance"
            @cancel="openCreateIssuance = false"
            @save="handleSave"
        /> -->

        <previe-nota-fiscal-view 
            :open="openPreview"
            :notasFiscalPreVisualizacao="previewNf"
            @back="openPreview = false"
        />

        <alert-cancel-view
            :isOpen="openAlertCancel"
            @cancel="openAlertCancel = false"
            @confirmar="confirmCancel"
        />

        <preview-nota-fiscal-servico-view 
            :open="openPreviewNfServico"
            :notaInfo="previewNf"
            @close="openPreviewNfServico = false"
        />

        <v-dialog
            v-model="errorValidationDialog"
            max-width="800"
        >
            <v-card>
                <v-card-title class="headline">
                    {{ errorValidationTitle }}
                </v-card-title>
                <v-card-text>
                    <div v-if="errorValidationMessages && errorValidationMessages.length">
                        <ul>
                            <li
                                v-for="(msg, index) in errorValidationMessages"
                                :key="index"
                            >
                                {{ msg }}
                            </li>
                        </ul>
                    </div>
                    <div v-else>
                        Ocorreu uma falha na validação da prévia da DANFe.
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" text @click="errorValidationDialog = false">
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="rejectionReasonDialog"
            max-width="700"
        >
            <v-card>
                <v-card-title class="headline error white--text">
                    {{ rejectionReasonTitle }}
                </v-card-title>
                <v-card-text class="error--text pt-6">
                    {{ rejectionReasonMessage || 'A nota fiscal foi rejeitada, mas a API nao retornou um motivo.' }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="error" text @click="rejectionReasonDialog = false">
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogConfirmarExclusao"
            max-width="560"
            persistent
        >
            <v-card>
                <v-card-title class="headline">
                    Confirmação
                </v-card-title>
                <v-card-text>
                    Ao confirmar a nota fiscal será excluída !
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="cancelarExclusao">Cancelar</v-btn>
                    <v-btn color="error" dark :loading="loadingExcluir" @click="confirmarExclusao">Confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
//import CreateIssuanceInvoiceView from './CreateIssuanceInvoiceView.vue';
import Vue from 'vue';
import axios from 'axios';
import PrevieNotaFiscalView from './PrevieNotaFiscalView.vue';
import AlertCancelView from './AlertCancelView.vue';
import moment from 'moment';
import PreviewNotaFiscalServicoView from './PreviewNotaFiscalServicoView.vue';
import EntityService from '../../services/entityService';
import SaidaEstoqueNotaFiscalService from '../../api/v2/services/SaidaEstoqueNotaFiscalService';

export default {
    name: 'IssuanceInvoiceView',
    components: {
        PrevieNotaFiscalView,
        AlertCancelView,
        PreviewNotaFiscalServicoView
        //CreateIssuanceInvoiceView
    },
    data(){
        return {
            emissaoDocEntity: new EntityService('EmissaoNotasFiscais'),
            fisPreDocEmiEntity: new EntityService('FisPreDocEmi'),
            fisDocServiceEntity: new EntityService('FisDocService'),
            optionTypeNf: [
                'Nota Fiscal', 
                'Nota Fiscal de Remessa',
                'Nota Fiscal de Serviço'
            ],
            isCfopsNfMae: ['6922'],
            previewNf: null,
            openAlertCancel: false,
            openPreviewNfServico: false,
            openPreview: false,
            openCreateIssuance: false,
            itemsData: [],
            headers: [
                { text: 'Tipo da NF', value: 'tipoNotaFiscal' },
                { text: 'Status', value: 'statusNf' },
                { text: 'Chave de Acesso', value: 'chaveAcesso' },
                { text: 'Número da NF', value: 'numeroNf' },
                { text: 'Número do JOB', value: 'jobNumero' },
                { text: 'Valor com Impostos', value: 'displayValueNf' },
                { text: 'Destinatario', value: 'destinatario' },
                { text: 'Data de Criação', value: 'createAt' },
                { text: 'Ações', value: 'actions'}
            ],
            page: 1,
            pageCount: 0,
            itemsPerPage: 30,
            itemNf: null,
            authorizate: null,
            baseUrl: process.env.VUE_APP_PLUGNOTAS_API_URL || 'https://api.sandbox.plugnotas.com.br',
            apiKey: process.env.VUE_APP_PLUGNOTAS_API_X_API_KEY || '2da392a6-79d2-4304-a8b7-959572c7e44d',
            errorValidationDialog: false,
            errorValidationTitle: 'Falha na validação da prévia da DANFe',
            errorValidationMessages: [],
            rejectionReasonDialog: false,
            rejectionReasonTitle: 'Nota fiscal rejeitada',
            rejectionReasonMessage: '',
            dialogConfirmarExclusao: false,
            loadingExcluir: false,
            itemExcluirSelecionado: null,
            mapaJobCodigo: {},
            listaNotasBase: [],
            filtroTipoNf: null,
            filtroStatusNf: null,
            filtroNumeroNf: null,
            filtroJobNumero: null,
            filtroDestinatario: null
        }
    },
    computed: {
        resumoTotalizadores() {
            return (this.listaNotasBase || []).reduce((accumulator, item = {}) => {
                const tipo = this.getTipoNotaFiscalLabel(item)
                const status = this.getStatusNfLabel(item)
                const statusNormalizado = this.normalizarTexto(status)
                const valorComImpostos = Number(item.displayValueNf ?? item.valueNf ?? 0) || 0

                if (statusNormalizado === 'emitida') {
                    accumulator.quantidadeEmitidas += 1

                    if (tipo === 'Venda') {
                        accumulator.totalVenda += valorComImpostos
                    }

                    if (tipo === 'Remessa') {
                        accumulator.totalRemessa += valorComImpostos
                    }
                }

                if (statusNormalizado === 'cancelada') {
                    accumulator.quantidadeCanceladas += 1
                }

                return accumulator
            }, {
                totalVenda: 0,
                totalRemessa: 0,
                quantidadeEmitidas: 0,
                quantidadeCanceladas: 0
            })
        },

        totalizadores() {
            return [
                {
                    titulo: 'Total NF Venda',
                    valor: this.formatCurrency(this.resumoTotalizadores.totalVenda),
                    classe: 'totalizador-card--venda'
                },
                {
                    titulo: 'Total NF Remessa',
                    valor: this.formatCurrency(this.resumoTotalizadores.totalRemessa),
                    classe: 'totalizador-card--remessa'
                },
                {
                    titulo: 'Notas Emitidas',
                    valor: String(this.resumoTotalizadores.quantidadeEmitidas),
                    classe: 'totalizador-card--emitidas'
                },
                {
                    titulo: 'Notas Canceladas',
                    valor: String(this.resumoTotalizadores.quantidadeCanceladas),
                    classe: 'totalizador-card--canceladas'
                }
            ]
        }
    },
    methods: {
        async mergeEntityPayload(schemaName, id, updates = {}) {
            const response = await Vue.prototype.$http.get(`/Entity/${schemaName}/${id}`)
            const entity = response?.data?.data || {}

            return {
                ...entity,
                ...updates,
                id: entity?.id || entity?._id || id,
                _id: undefined
            }
        },

        getRelationEntityId(value) {
            if (Array.isArray(value)) return this.getRelationEntityId(value[0])
            if (value && typeof value === 'object') return value?._id || value?.id || ''
            return value || ''
        },

        async vincularFisDocEmiAosRomaneios(romaneios = [], fisDocEmiId = '') {
            const idsRomaneios = [...new Set((romaneios || [])
                .map((romaneio) => this.getRelationEntityId(romaneio))
                .filter(Boolean)
                .map(String))]

            if (!fisDocEmiId || !idsRomaneios.length) return

            const conflitos = []

            for (const romaneioId of idsRomaneios) {
                const payload = await this.mergeEntityPayload('Romaneio', romaneioId)
                const vinculoAtual = String(this.getRelationEntityId(payload?.fisDocEmiId) || '')

                if (vinculoAtual === String(fisDocEmiId)) continue

                if (vinculoAtual) {
                    conflitos.push(payload?.codigo || romaneioId)
                    continue
                }

                payload.fisDocEmiId = fisDocEmiId
                const response = await Vue.prototype.$http.put('/Entity/Romaneio', payload)

                if (!response || response.status < 200 || response.status >= 300 || response?.data?.errors) {
                    throw new Error(`Não foi possível vincular a nota emitida ao romaneio ${payload?.codigo || romaneioId}.`)
                }
            }

            if (conflitos.length > 0) {
                this.$notfy.warning(`O(s) romaneio(s) ${conflitos.join(', ')} já está(ão) vinculado(s) a outra nota fiscal e não foi(ram) alterado(s).`)
            }
        },

        normalizarTexto(value = '') {
            return String(value || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim()
        },

        getStatusNfLabel(item = {}) {
            return item?.statusNf == 'Denegada' ? 'Cancelada' : (item?.statusNf || '')
        },

        getTipoNotaFiscalLabel(item = {}) {
            const tipo = String(item?.tipoNotaFiscal || '').trim()

            if (tipo === 'Nota_Fiscal_de_Remessa') return 'Remessa'
            if (tipo === 'Nota_Fiscal') return 'Venda'

            return tipo.replaceAll('_', ' ') || 'Não Informado'
        },

        getNumeroNf(item = {}) {
            try {
                const plugResponse = JSON.parse(item?.plugNotasResponse || '[]')
                return plugResponse?.[0]?.numero || item?.numeroNf || 'Não Informado'
            } catch (_) {
                return item?.numeroNf || 'Não Informado'
            }
        },

        getDestinatarioNome(item = {}) {
            return item?.notaFiscalDeRemessa ? item?.destinatarioFornecedorNome : item?.destinatarioNome
        },

        buildUniqueOptions(values = []) {
            const unicos = Array.from(new Set((values || [])
                .map((item) => String(item || '').trim())
                .filter(Boolean)))

            return unicos
                .sort((a, b) => a.localeCompare(b, 'pt-BR', { sensitivity: 'base' }))
                .map((valor) => ({ text: valor, value: valor }))
        },

        getOpcoesTipoNf() {
            return this.buildUniqueOptions((this.listaNotasBase || []).map((item) => this.getTipoNotaFiscalLabel(item)))
        },

        getOpcoesStatusNf() {
            return this.buildUniqueOptions((this.listaNotasBase || []).map((item) => this.getStatusNfLabel(item)))
        },

        getOpcoesNumeroNf() {
            return this.buildUniqueOptions((this.listaNotasBase || []).map((item) => this.getNumeroNf(item)))
        },

        getOpcoesJobNumero() {
            return this.buildUniqueOptions((this.listaNotasBase || []).map((item) => this.getJobNumero(item)))
        },

        getOpcoesDestinatario() {
            return this.buildUniqueOptions((this.listaNotasBase || []).map((item) => this.getDestinatarioNome(item)))
        },

        isFiltroSelecionadoIgual(valorLinha = '', valorFiltro = null) {
            if (!valorFiltro) return true
            return this.normalizarTexto(valorLinha) === this.normalizarTexto(valorFiltro)
        },

        filtrarListaNotas(lista = []) {
            return (lista || []).filter((item = {}) => {
                const tipoOk = this.isFiltroSelecionadoIgual(this.getTipoNotaFiscalLabel(item), this.filtroTipoNf)
                const statusOk = this.isFiltroSelecionadoIgual(this.getStatusNfLabel(item), this.filtroStatusNf)
                const numeroOk = this.isFiltroSelecionadoIgual(this.getNumeroNf(item), this.filtroNumeroNf)
                const jobOk = this.isFiltroSelecionadoIgual(this.getJobNumero(item), this.filtroJobNumero)
                const destinatarioOk = this.isFiltroSelecionadoIgual(this.getDestinatarioNome(item), this.filtroDestinatario)

                return tipoOk && statusOk && numeroOk && jobOk && destinatarioOk
            })
        },

        atualizarTabelaFiltrada() {
            const listaFiltrada = this.filtrarListaNotas(this.listaNotasBase)

            const totalPaginas = Math.ceil((listaFiltrada.length || 0) / this.itemsPerPage)
            this.pageCount = totalPaginas

            if (this.page > totalPaginas && totalPaginas > 0) {
                this.page = totalPaginas
            }

            if (totalPaginas === 0) {
                this.page = 1
                this.itemsData = []
                return
            }

            const inicio = (this.page - 1) * this.itemsPerPage
            const fim = inicio + this.itemsPerPage
            this.itemsData = listaFiltrada.slice(inicio, fim)
        },

        handleFiltroChange() {
            this.page = 1
            this.atualizarTabelaFiltrada()
        },

        extrairListaDaResposta(response) {
            const lista = response?.data?.data?.data || response?.data?.data || response?.data || []
            return Array.isArray(lista) ? lista : []
        },

        extrairJobId(item = {}) {
            const notaFiscal = Array.isArray(item?.notaFiscal) ? item.notaFiscal[0] : item?.notaFiscal
            const notaFiscalServico = Array.isArray(item?.notaFiscalServico) ? item.notaFiscalServico[0] : item?.notaFiscalServico

            const jobValue =
                item?.job ||
                notaFiscal?.job ||
                notaFiscalServico?.job ||
                item?.project ||
                notaFiscal?.project ||
                notaFiscalServico?.project

            if (jobValue && typeof jobValue === 'object') return jobValue.id || jobValue._id || ''
            return jobValue || ''
        },

        async carregarMapaJobCodigoPorIds(items = []) {
            const idsJob = Array.from(new Set((items || [])
                .map((item = {}) => this.extrairJobId(item))
                .filter(Boolean)
                .map((id) => String(id))))

            if (!idsJob.length) return

            const faltantes = idsJob.filter((id) => !this.mapaJobCodigo[id])
            if (!faltantes.length) return

            const response = await Vue.prototype.$http.post('/View/run?limit=100000000', {
                params: [],
                viewName: 'job',
                page: 1,
                limit: 100000000
            })

            const jobs = this.extrairListaDaResposta(response)
            const mapa = { ...this.mapaJobCodigo }

            jobs.forEach((job = {}) => {
                const id = String(job?.id || job?._id || '').trim()
                if (!id) return
                mapa[id] = job?.code || job?.codigo || job?.jobCode || ''
            })

            this.mapaJobCodigo = mapa
        },

        getJobNumero(item = {}) {
            const notaFiscal = Array.isArray(item?.notaFiscal) ? item.notaFiscal[0] : item?.notaFiscal;
            const notaFiscalServico = Array.isArray(item?.notaFiscalServico) ? item.notaFiscalServico[0] : item?.notaFiscalServico;

            const jobValue =
                item?.jobCode ||
                item?.jobCodigo ||
                item?.jobNumero ||
                notaFiscal?.jobCode ||
                notaFiscal?.jobCodigo ||
                notaFiscalServico?.jobCode ||
                notaFiscalServico?.jobCodigo ||
                item?.job ||
                notaFiscal?.job ||
                notaFiscalServico?.job;

            if (jobValue && typeof jobValue === 'object') {
                return jobValue.code || jobValue.codigo || jobValue.name || jobValue.nome || 'Não Informado';
            }

            const jobId = String(this.extrairJobId(item) || '').trim()
            if (jobId && this.mapaJobCodigo[jobId]) {
                return this.mapaJobCodigo[jobId]
            }

            return jobValue || 'Não Informado';
        },

        formatCurrency(value) {
            return Number(value || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
        },

        toMonetaryValue(value) {
            const numericValue = Number(value || 0)

            if (!Number.isFinite(numericValue)) return 0

            return numericValue / 100
        },

        async getInvoiceDisplayValue(item) {
            if (item?.tipoNotaFiscal === 'Nota_Fiscal_de_Serviço') {
                return Number(item.valueNf || 0)
            }

            const notaFiscal = item?.notaFiscal?.[0]
            const itemIds = notaFiscal?.itens || []

            if (!Array.isArray(itemIds) || itemIds.length === 0) {
                return Number(item.valueNf || 0)
            }

            const response = await Vue.prototype.$http.get('/Entity/FisPreDocEmiItem/search-fields', {
                params: {
                    ids: itemIds.join(','),
                    sortField: 'sequencia'
                }
            })

            const nfItems = response?.data?.data?.data || []

            const totals = nfItems.reduce((accumulator, nfItem) => {
                accumulator.ipi += this.toMonetaryValue(nfItem.ipiValor)
                accumulator.frete += this.toMonetaryValue(nfItem.valorFrete)
                accumulator.seguro += this.toMonetaryValue(nfItem.valorSeguro)
                accumulator.desconto += this.toMonetaryValue(nfItem.valorDesconto)
                accumulator.outros += this.toMonetaryValue(nfItem.valorOutros)
                return accumulator
            }, {
                ipi: 0,
                frete: 0,
                seguro: 0,
                desconto: 0,
                outros: 0
            })

            return Number(item.valueNf || 0)
                + totals.ipi
                + totals.frete
                + totals.seguro
                - totals.desconto
                + totals.outros
        },

        calculateInvoiceDisplayValue(item, itemsMap) {
            if (item?.tipoNotaFiscal === 'Nota_Fiscal_de_Serviço') {
                return Number(item.valueNf || 0)
            }

            const notaFiscal = item?.notaFiscal?.[0]
            const itemIds = notaFiscal?.itens || []

            if (!Array.isArray(itemIds) || itemIds.length === 0) {
                return Number(item.valueNf || 0)
            }

            const totals = itemIds.reduce((accumulator, id) => {
                const nfItem = itemsMap[id]

                if (!nfItem) return accumulator

                accumulator.ipi += this.toMonetaryValue(nfItem.ipiValor)
                accumulator.frete += this.toMonetaryValue(nfItem.valorFrete)
                accumulator.seguro += this.toMonetaryValue(nfItem.valorSeguro)
                accumulator.desconto += this.toMonetaryValue(nfItem.valorDesconto)
                accumulator.outros += this.toMonetaryValue(nfItem.valorOutros)

                return accumulator
            }, {
                ipi: 0,
                frete: 0,
                seguro: 0,
                desconto: 0,
                outros: 0
            })

            return Number(item.valueNf || 0)
                + totals.ipi
                + totals.frete
                + totals.seguro
                - totals.desconto
                + totals.outros
        },

        async enrichInvoiceDisplayValues(items) {
            const allItemIds = [
                ...new Set(
                    (items || []).flatMap(item =>
                        item?.notaFiscal?.[0]?.itens || []
                    )
                )
            ]

            let itemsMap = {}

            if (allItemIds.length > 0) {
                const response =
                    await Vue.prototype.$http.get(
                        '/Entity/FisPreDocEmiItem/search-fields',
                        {
                            params: {
                                ids: allItemIds.join(','),
                                sortField: 'sequencia'
                            }
                        }
                    )

                const nfItems =
                    response?.data?.data?.data || []

                itemsMap = nfItems.reduce((acc, item) => {
                    acc[item.id] = item
                    return acc
                }, {})
            }

            return (items || []).map(item => ({
                ...item,
                displayValueNf: this.calculateInvoiceDisplayValue(
                    item,
                    itemsMap
                )
            }))
        },

        getColorBadge(status) {
            switch (status) {
                case 'Emitida':
                return { color: 'primary', icon: 'mdi-check-circle' };

                case 'Processando':
                return { color: 'warning', icon: 'mdi-loading' };

                case 'Rejeitado':
                case 'Rejeitada':
                return { color: 'error', icon: 'mdi-alert-circle' };

                case 'Denegada':
                return { color: 'error', icon: 'mdi-close-circle' };

                default:
                return { color: 'grey', icon: 'mdi-help-circle' };
            }
        },

        getResumoInvoiceStatus(status, statusAtual = 'Processando') {
            switch (status) {
                case 'CONCLUIDO':
                    return 'Emitida'
                case 'REJEITADO':
                case 'REJEITADA':
                    return 'Rejeitada'
                case 'PENDENTE':
                    return 'Processando'
                case 'CANCELADO':
                    return 'Denegada'
                default:
                    return statusAtual || 'Processando'
            }
        },

        getResumoPreNotaStatus(status, statusAtual = '') {
            switch (String(status || '').trim().toUpperCase()) {
                case 'REJEITADO':
                case 'REJEITADA':
                    return 'REJEITADO'
                case 'PENDENTE':
                    return 'PROCESSANDO'
                case 'CONCLUIDO':
                    return statusAtual || 'EMITIDA'
                default:
                    return statusAtual
            }
        },

        isStatusPendente(status = '') {
            return String(status || '').trim().toLowerCase() === 'pendente'
        },

        isStatusBloqueadoEdicao(status = '') {
            const statusNormalizado = String(status || '').trim().toLowerCase()
            return ['emitida', 'cancelada', 'denegada', 'processando'].includes(statusNormalizado)
        },

        isStatusProcessando(status = '') {
            return String(status || '').trim().toLowerCase() === 'processando'
        },

        isStatusConsultavel(status = '') {
            const statusNormalizado = String(status || '').trim().toLowerCase()
            return ['processando', 'rejeitada', 'rejeitado'].includes(statusNormalizado)
        },

        isStatusCancelada(status = '') {
            const statusNormalizado = String(status || '').trim().toLowerCase()
            return ['cancelada', 'denegada'].includes(statusNormalizado)
        },

        openRejectionReasonModal(message) {
            this.rejectionReasonTitle = 'Nota fiscal rejeitada'
            this.rejectionReasonMessage = message || 'A nota fiscal foi rejeitada, mas a API nao retornou um motivo.'
            this.rejectionReasonDialog = true
        },

        getPrimeiroIdFisDocEmi(origem = null) {
            if (!origem) return null

            if (Array.isArray(origem)) {
                const primeiro = origem[0] || {}
                if (typeof primeiro === 'string') return primeiro || null
                return primeiro?._id || primeiro?.id || null
            }

            if (typeof origem === 'string') return origem || null

            return origem?._id || origem?.id || null
        },

        getListaFromEntitySearch(response = null) {
            if (Array.isArray(response?.data?.data?.data)) return response.data.data.data
            if (Array.isArray(response?.data?.data)) return response.data.data
            if (Array.isArray(response?.data)) return response.data
            return []
        },

        async resolverIdFisDocEmi(infoNf = {}) {
            let idFisDocEmi = this.getPrimeiroIdFisDocEmi(infoNf?.notaFiscalEmitida)
            if (idFisDocEmi) return idFisDocEmi

            const idPreNota = infoNf?.notaFiscal?.[0]?._id || infoNf?.notaFiscal?.[0]?.id
            const plugNotasId = infoNf?.plugNotasID

            if (idPreNota) {
                const responseByPreNota = await Vue.prototype.$http.get('/Entity/FisDocEmi/search-fields', {
                    params: {
                        searchFields: 'preNota',
                        value: idPreNota,
                        page: 1,
                        limit: 1,
                        mode: 'Equals'
                    }
                })

                idFisDocEmi = this.getPrimeiroIdFisDocEmi(this.getListaFromEntitySearch(responseByPreNota))
                if (idFisDocEmi) return idFisDocEmi
            }

            if (plugNotasId) {
                const responseByPlugNotasId = await Vue.prototype.$http.get('/Entity/FisDocEmi/search-fields', {
                    params: {
                        searchFields: 'plugNotasId',
                        value: plugNotasId,
                        page: 1,
                        limit: 1,
                        mode: 'Equals'
                    }
                })

                idFisDocEmi = this.getPrimeiroIdFisDocEmi(this.getListaFromEntitySearch(responseByPlugNotasId))
            }

            return idFisDocEmi || null
        },

        async resolverIdsFisDocEmi(infoNf = {}) {
            const ids = new Set()

            const idDireto = this.getPrimeiroIdFisDocEmi(infoNf?.notaFiscalEmitida)
            if (idDireto) ids.add(String(idDireto))

            const idPreNota = infoNf?.notaFiscal?.[0]?._id || infoNf?.notaFiscal?.[0]?.id
            const plugNotasId = infoNf?.plugNotasID

            if (idPreNota) {
                const responseByPreNota = await Vue.prototype.$http.get('/Entity/FisDocEmi/search-fields', {
                    params: {
                        searchFields: 'preNota',
                        value: idPreNota,
                        page: 1,
                        limit: 100,
                        mode: 'Equals'
                    }
                })

                this.getListaFromEntitySearch(responseByPreNota).forEach((item = {}) => {
                    const id = this.getPrimeiroIdFisDocEmi(item)
                    if (id) ids.add(String(id))
                })
            }

            if (plugNotasId) {
                const responseByPlugNotasId = await Vue.prototype.$http.get('/Entity/FisDocEmi/search-fields', {
                    params: {
                        searchFields: 'plugNotasId',
                        value: plugNotasId,
                        page: 1,
                        limit: 100,
                        mode: 'Equals'
                    }
                })

                this.getListaFromEntitySearch(responseByPlugNotasId).forEach((item = {}) => {
                    const id = this.getPrimeiroIdFisDocEmi(item)
                    if (id) ids.add(String(id))
                })
            }

            return Array.from(ids)
        },

        async atualizarStatusFisDocEmiPorInfo(infoNf = {}, statusEmissao = 'CANCELADA') {
            const idsFisDocEmi = await this.resolverIdsFisDocEmi(infoNf)
            if (!idsFisDocEmi.length) return

            await Promise.all(idsFisDocEmi.map(async (idFisDocEmi) => {
                const objFisDocEmi = await this.mergeEntityPayload('FisDocEmi', idFisDocEmi, {
                    statusEmissao
                })

                return Vue.prototype.$http.put('/Entity/FisDocEmi', objFisDocEmi)
            }))
        },

        async forcarPutStatusFisDocEmiCancelada(infoNf = {}, plugNotasId = '') {
            const ids = new Set()

            const idDireto = this.getPrimeiroIdFisDocEmi(infoNf?.notaFiscalEmitida)
            if (idDireto) ids.add(String(idDireto))

            const idPreNota = infoNf?.notaFiscal?.[0]?._id || infoNf?.notaFiscal?.[0]?.id

            if (idPreNota) {
                const responseByPreNota = await Vue.prototype.$http.get('/Entity/FisDocEmi/search-fields', {
                    params: {
                        searchFields: 'preNota',
                        value: idPreNota,
                        page: 1,
                        limit: 100,
                        mode: 'Equals'
                    }
                })

                this.getListaFromEntitySearch(responseByPreNota).forEach((item = {}) => {
                    const id = item?._id || item?.id
                    if (id) ids.add(String(id))
                })
            }

            if (plugNotasId) {
                const responseByPlugNotasId = await Vue.prototype.$http.get('/Entity/FisDocEmi/search-fields', {
                    params: {
                        searchFields: 'plugNotasId',
                        value: plugNotasId,
                        page: 1,
                        limit: 100,
                        mode: 'Equals'
                    }
                })

                this.getListaFromEntitySearch(responseByPlugNotasId).forEach((item = {}) => {
                    const id = item?._id || item?.id
                    if (id) ids.add(String(id))
                })
            }

            const idsFisDocEmi = Array.from(ids)
            if (!idsFisDocEmi.length) return 0

            for (const id of idsFisDocEmi) {
                const payloadFisDocEmi = await this.mergeEntityPayload('FisDocEmi', id, {
                    statusEmissao: 'CANCELADA'
                })

                await Vue.prototype.$http.put('/Entity/FisDocEmi', payloadFisDocEmi)
            }

            return idsFisDocEmi.length
        },

        getChaveAcesso(response) {
            const data = JSON.parse(response)
            if(data?.length > 0 && data[0]?.chave){
                return data?.[0]?.chave
            } else if(data?.message){
                return data?.message
            } else {
                return 'Não Informado'
            }
        },

        async getIssuanceInvoices(){
            const response = await Vue.prototype.$http.post(`/View/run`,
                {
                    "params": [],
                    "viewId": "2a39c593-02d0-46d4-be8c-6dc43dc18c9a",
                    "page": 1,
                    "limit": 100000000
                }
            );

            const lista = this.extrairListaDaResposta(response)
            await this.carregarMapaJobCodigoPorIds(lista)
            this.listaNotasBase = await this.enrichInvoiceDisplayValues(lista)
            this.atualizarTabelaFiltrada()
        },
        pagination(page) {
            this.page = page
            this.atualizarTabelaFiltrada()
        },
        async handleSave(){
            this.openCreateIssuance = false
            await this.getIssuanceInvoices()
        },

        createValue(){
            this.itemNf = null
            this.openCreateIssuance = true
        },

        getEntityRecordId(record) {
            if (!record) return null

            if (Array.isArray(record)) {
                return this.getEntityRecordId(record[0])
            }

            return record._id || record.id || record
        },

        getEntityRecord(record) {
            if (!record) return null

            if (Array.isArray(record)) {
                return record[0] || null
            }

            return typeof record === 'object' ? record : null
        },

        extrairPrimeiroRegistro(response) {
            const lista =
                response?.data?.data?.data ||
                response?.data?.data ||
                response?.data ||
                []

            if (Array.isArray(lista)) return lista[0] || null
            if (lista && typeof lista === 'object') return lista
            return null
        },

        async resolverRegistroOriginalEmissao(item = {}) {
            const idDireto = this.getEntityRecordId(item)

            if (idDireto) {
                try {
                    const resp = await this.emissaoDocEntity.getById(idDireto)
                    const registro = this.extrairPrimeiroRegistro(resp)
                    if (registro && (registro.id || registro._id)) return registro
                } catch (_) {
                    // tenta próximas estratégias
                }
            }

            const filtrosBusca = [
                ['plugNotasID', item?.plugNotasID],
                ['chaveAcesso', item?.chaveAcesso],
                ['plugNotaIdIntegracao', item?.plugNotaIdIntegracao]
            ].filter(([, valor]) => Boolean(valor))

            for (const [campo, valor] of filtrosBusca) {
                try {
                    const resp = await this.emissaoDocEntity.search(campo, valor, 1, 1, null, 'Equals')
                    const registro = this.extrairPrimeiroRegistro(resp)
                    if (registro && (registro.id || registro._id)) return registro
                } catch (_) {
                    // continua tentando outros campos
                }
            }

            return null
        },

        async confirmarExclusaoAplicada(item = {}) {
            const registro = await this.resolverRegistroOriginalEmissao(item)
            if (!registro || typeof registro !== 'object') return false
            return Boolean(registro.isDeleted)
        },

        notaExisteNaLista(item = {}, lista = []) {
            const chave = item?.chaveAcesso || ''
            const plugNotasID = item?.plugNotasID || ''
            const id = this.getEntityRecordId(item)

            return (lista || []).some((linha = {}) => {
                const idLinha = this.getEntityRecordId(linha)
                if (id && idLinha && String(idLinha) === String(id)) return true
                if (chave && String(linha?.chaveAcesso || '') === String(chave)) return true
                if (plugNotasID && String(linha?.plugNotasID || '') === String(plugNotasID)) return true
                return false
            })
        },

        async deleteEntityItems(schemaName, ids = []) {
            const validIds = (ids || []).filter(Boolean)

            if (!validIds.length) return

            await Promise.all(
                validIds.map((id) => Vue.prototype.$http.delete(`/Entity/${schemaName}?id=${id}`))
            )
        },

        abrirConfirmacaoExclusao(item) {
            if (!this.isStatusPendente(item?.statusNf)) {
                this.$notfy.warning('A nota fiscal só pode ser excluída quando estiver com status Pendente.')
                return
            }

            this.itemExcluirSelecionado = item || null
            this.dialogConfirmarExclusao = true
        },

        cancelarExclusao() {
            this.dialogConfirmarExclusao = false
            this.itemExcluirSelecionado = null
        },

        async confirmarExclusao() {
            if (!this.itemExcluirSelecionado) return

            if (!this.isStatusPendente(this.itemExcluirSelecionado?.statusNf)) {
                this.$notfy.warning('A nota fiscal só pode ser excluída quando estiver com status Pendente.')
                this.dialogConfirmarExclusao = false
                this.itemExcluirSelecionado = null
                return
            }

            this.loadingExcluir = true
            try {
                let entidadeOriginal = await this.resolverRegistroOriginalEmissao(this.itemExcluirSelecionado)

                if (!entidadeOriginal || typeof entidadeOriginal !== 'object' || Array.isArray(entidadeOriginal)) {
                    this.$notfy.error('Não foi possível excluir: registro da entidade EmissaoNotasFiscais não foi encontrado.')
                    return
                }

                const id = entidadeOriginal.id || entidadeOriginal._id

                const payload = {
                    ...entidadeOriginal,
                    id: entidadeOriginal.id || entidadeOriginal._id || id,
                    isDeleted: true
                }

                delete payload._id
                delete payload.displayValueNf
                delete payload.destinatarioInfo
                delete payload.destinatarioInfoFornecedor
                delete payload.jobNumero
                delete payload.numeroNf

                const token = await Vue.prototype.$auth.getUserToken()
                const responseExclusao = await axios.put(
                    `${process.env.VUE_APP_API_URL}/Entity/EmissaoNotasFiscais`,
                    payload,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                        validateStatus: () => true
                    }
                )

                const statusOk = responseExclusao?.status >= 200 && responseExclusao?.status < 300
                if (!statusOk) {
                    let exclusaoConfirmada = await this.confirmarExclusaoAplicada(this.itemExcluirSelecionado)

                    if (!exclusaoConfirmada) {
                        await this.getIssuanceInvoices()
                        exclusaoConfirmada = !this.notaExisteNaLista(this.itemExcluirSelecionado, this.itemsData)
                    }

                    if (!exclusaoConfirmada) {
                        const erroApi = responseExclusao?.data?.data?.[0]?.value || responseExclusao?.statusText || 'Falha ao excluir nota fiscal.'
                        throw new Error(erroApi)
                    }
                }

                this.$notfy.success('Nota fiscal excluída com sucesso.')
                this.dialogConfirmarExclusao = false
                this.itemExcluirSelecionado = null
                await this.getIssuanceInvoices()
            } catch (error) {
                let exclusaoConfirmada = false

                try {
                    exclusaoConfirmada = await this.confirmarExclusaoAplicada(this.itemExcluirSelecionado)
                } catch (_) {
                    exclusaoConfirmada = false
                }

                if (exclusaoConfirmada) {
                    this.$notfy.success('Nota fiscal excluída com sucesso.')
                    this.dialogConfirmarExclusao = false
                    this.itemExcluirSelecionado = null
                    await this.getIssuanceInvoices()
                } else {
                    this.dialogConfirmarExclusao = false
                    this.itemExcluirSelecionado = null
                    this.$notfy.error('Erro ao excluir nota fiscal.', error?.response?.data || error?.message)
                    console.error('Erro ao excluir nota fiscal:', error?.response?.data || error?.message)
                }
            } finally {
                this.loadingExcluir = false
            }
        },
        
        editValue(value){
            if (this.isStatusBloqueadoEdicao(value?.statusNf)) {
                this.$notfy.warning('A nota fiscal com status Emitida, Cancelada ou Processando não pode ser editada.')
                return
            }

            this.$router.push({
                name: 'CreateIssuance',
                params: { typeNf: value.tipoNotaFiscal.replaceAll('_', ' ') },
                query: {
                    id: value._id
                }
            })
        },

        duplicateValue(value){
            this.$router.push({
                name: 'CreateIssuance',
                params: { typeNf: value.tipoNotaFiscal.replaceAll('_', ' ') },
                query: {
                    id: value._id,
                    duplicate: '1'
                }
            })
        },

        async geratedPdf(itemNf){
            let file
            let fileName = itemNf.tipoNotaFiscal === 'Nota_Fiscal_de_Serviço' ? 'nota-fiscal-serviço.pdf' : 'nota-fiscal.pdf'

            if(itemNf.tipoNotaFiscal !== 'Nota_Fiscal_de_Serviço'){
                let plugResponse = JSON.parse(itemNf.plugNotasResponse)[0]
                file = await axios.get(plugResponse.pdf,
                    {
                        headers: {
                            'X-API-KEY': this.apiKey,
                            'Content-Type': 'application/json'
                        },
                        responseType: 'blob'
                    }
                )
            } else {
                let plugResponse = JSON.parse(itemNf.plugNotasResponse)
                file = await axios.get(`${this.baseUrl}/nfse/pdf/${plugResponse.id}`,
                    {
                        headers: {
                            'X-API-KEY': this.apiKey,
                            'Content-Type': 'application/json'
                        },
                        responseType: 'blob'
                    }
                )
            }

            const url = window.URL.createObjectURL(new Blob([file.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();

        },
        
        async geratedXml(itemNf){
            let file

            if(itemNf.tipoNotaFiscal !== 'Nota_Fiscal_de_Serviço'){
                let plugResponse = JSON.parse(itemNf.plugNotasResponse)[0]
                file = await axios.get(plugResponse.xml,
                    {
                        headers: {
                            'X-API-KEY': this.apiKey,
                            'Content-Type': 'application/json'
                        },
                        responseType: 'blob'
                    }
                )
            } else {

                let plugResponse = JSON.parse(itemNf.plugNotasResponse)
                file = await axios.get(`${this.baseUrl}/nfse/xml/${plugResponse.id}`,
                    {
                        headers: {
                            'X-API-KEY': this.apiKey,
                            'Content-Type': 'application/json'
                        },
                        responseType: 'blob'
                    }
                )
            }
            
            const url = window.URL.createObjectURL(new Blob([file.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'nota-fiscal.xml');
            document.body.appendChild(link);
            link.click();
            link.remove();

        },

        async resumoNotaFiscalServico(nfInfo){
            this.$notfy.warning(`Gerando o resumo da nota fiscal.`)
            
            let plugResponse = JSON.parse(nfInfo.plugNotasResponse)
            console.log('plugResponse >>> ', plugResponse)
            let id = plugResponse.documents[0]?.id

            /*
                                'https://api.plugnotas.com.br/nfse',
                    nfData,
                    {
                        headers: {
                            'X-API-KEY': '21c94f51-ca20-4ba0-a6d2-ffc23291680c',
                            'Content-Type': 'application/json'
                        }
                    }
            */

            const response = await axios.get(`${this.baseUrl}/nfse/${id}`, {
                headers: {
                    'X-API-KEY': this.apiKey,
                    'Content-Type': 'application/json'
                },
            });


            const objEmissao = {
                plugNotasID: nfInfo.plugNotasID,
                plugNotasMensagem: response.data.retorno.mensagemRetorno,
                plugNotaIdIntegracao: nfInfo.plugNotaIdIntegracao,
                tipoNotaFiscal: nfInfo.tipoNotaFiscal.replaceAll('_', ' '),
                destinatario: nfInfo.destinatario,
                destinatarioFornecedor: undefined,
                statusNf: response.data.status == "CONCLUIDO" ? "Emitida" : "",
                notaFiscalServico: nfInfo.notaFiscalServico[0]._id,
                valueNf: Number(nfInfo.valueNf),
                id: nfInfo._id,
                plugNotasResponse: JSON.stringify(response.data),
                chaveAcesso: response.data.retorno.codigoVerificacao,
                notaFiscalDeRemessa: nfInfo.notaFiscalDeRemessa
            }

            await Promise.all([
                Vue.prototype.$http.put('/Entity/EmissaoNotasFiscais', objEmissao),
                Vue.prototype.$http.put('/Entity/FisDocService', {
                    ...nfInfo.notaFiscalServico[0],
                    id: nfInfo.notaFiscalServico[0]._id,
                    _id: undefined,
                    jobItensList: undefined,
                    status: response.data.status == "CONCLUIDO" ? "Concluído" : "",
                    emitenteTipoEnquadramento: nfInfo.notaFiscalServico[0].emitenteTipoEnquadramento || '',
                    tomadorIm: nfInfo.notaFiscalServico[0].tomadorIm || '',
                    fornecedor: nfInfo.notaFiscalServico[0].fornecedor || '',
                    cnpj: nfInfo.notaFiscalServico[0].emitenteCpfOrCnpj || '',
                    numero: response.data.retorno.numeroNfse || '',
                    pedido: nfInfo.notaFiscalServico[0].pedido || '',
                    pdf: nfInfo.notaFiscalServico[0].pdf || undefined,
                    reasoning: nfInfo.notaFiscalServico[0].reasoning || '',
                    codigoCidade: nfInfo.notaFiscalServico[0].codigoCidade || '',
                    jobItens: nfInfo.notaFiscalServico[0].jobItens,
                    tributacao: undefined,
                    cnae: nfInfo.notaFiscalServico[0].cnae || undefined,
                    cnaeCodigo: nfInfo.notaFiscalServico[0].cnaeCodigo || undefined,
                    cnaeDescricao: nfInfo.notaFiscalServico[0].cnaeDescricao || undefined,
                    tributacaoMunicipal: nfInfo.notaFiscalServico[0].tributacaoMunicipal || undefined,
                    regimeTributario: nfInfo.notaFiscalServico[0].regimeTributario || undefined,
                    regimeTributarioCodigo: nfInfo.notaFiscalServico[0].regimeTributarioCodigo || undefined,
                    regimeTributarioDescricao: nfInfo.notaFiscalServico[0].regimeTributarioDescricao || undefined,
                    enquadramentoServico: nfInfo.notaFiscalServico[0].enquadramentoServico || undefined,
                    enquadramentoServicoCodigo: nfInfo.notaFiscalServico[0].enquadramentoServicoCodigo || undefined,
                    enquadramentoServicoDescricao: nfInfo.notaFiscalServico[0].enquadramentoServicoDescricao || undefined,
                    emitenteCnae: nfInfo.notaFiscalServico[0].emitenteCnae || undefined,
                    emitenteCodCidade: nfInfo.notaFiscalServico[0].emitenteCodCidade || undefined
                })
            ])

            if(response.data.status == "CONCLUIDO"){

                const responseParcelas = await Vue.prototype.$http.get('/Entity/FisPreDocEmiFin/search-fields', {
                    params: {
                        ids: nfInfo.notaFiscalServico[0]?.parcelas.map((item) => item ).join(',')
                    }
                })

                const parcelas = responseParcelas?.data?.data?.data

                let fisDocEmiFinIds = []
                let fisDocRecFinS = []
                let finRecCad = []

                let objItensFinRec = []

                if (parcelas?.length > 0) {
                    parcelas.forEach((p, index) => {
                        objItensFinRec.push({
                            status: "Prevista",
                            origem: "Nota Fiscal Emitida",
                            parcela: index + 1,
                            notaFiscalServico: nfInfo.notaFiscalServico[0]._id,
                            job: nfInfo.notaFiscalServico[0]?.job,
                            cliente: nfInfo.destinatario,
                            valorOriginal: p.vlr / 100,
                            valorRecebido: 0,
                            valorSaldo: p.vlr / 100,
                            dataCriacao:  moment().format("YYYY-MM-DD"),
                            dataVencimento: p.dtPag
                                ? moment(new Date(p.dtPag)).format("YYYY-MM-DD")
                                : moment(new Date(nfInfo.notaFiscalServico[0]?.dataSaida)).format("YYYY-MM-DD"),
                            descricao: "Gerado pela pré-nota " + nfInfo.notaFiscalServico[0]?.codigo,
                            observacao: "",
                        });
                    });

                    const responseInsertFinRec = await Vue.prototype.$http.post("/Entity/insertMany/FinRec", objItensFinRec)
                    finRecCad = responseInsertFinRec.data.data

                } else {

                    await Vue.prototype.$http.post("/Entity/FinRec", {
                        origem: "Nota Fiscal Emitida",
                        status: "Prevista",
                        parcela: nfInfo.notaFiscalServico[0].parcelas?.length || 1,
                        preNota: nfInfo.notaFiscalServico[0]._id,
                        job: nfInfo.notaFiscalServico[0].job,
                        cliente: nfInfo.destinatario,
                        valorOriginal: Number(nfInfo.valueNf),
                        dataCriacao:  moment().format("YYYY-MM-DD"),
                        dataVencimento: moment(nfInfo.notaFiscalServico[0]?.dataSaida).format('YYYY-MM-DD'),
                        descricao: "Gerado pela pré-nota " + nfInfo.notaFiscalServico[0]?.codigo,
                        observacao: "",
                        // notaFiscalEmitida: responseFisDocEmi.data.data.id
                    })
                }

                fisDocRecFinS = responseParcelas?.data?.data?.data?.map((item, index) => {

                    delete item.createAt
                    delete item.updateAt
                    delete item.createBy
                    delete item.updateBy
                    delete item.deleteAt
                    delete item.deleteBy
                    delete item.isDeleted
                    delete item.id

                    return {
                        ...item,
                        vlr: item.vlr / 100,
                        contaAReceber: finRecCad[index]?.id
                    }
                })

                //FisDocEmiFin
                const responseFisPreDocEmiItem = await Vue.prototype.$http.post('/Entity/insertMany/FisDocEmiFin', fisDocRecFinS)

                fisDocEmiFinIds = responseFisPreDocEmiItem?.data?.data?.map((item) => {
                    return item.id
                })

                const responseFisDocEmi = await Vue.prototype.$http.post('/Entity/FisDocEmi', {
                    job: nfInfo.notaFiscalServico[0]?.job,
                    preNota: nfInfo.notaFiscalServico[0]?._id,
                    // Mudar Aqui
                    filial: nfInfo.notaFiscalServico[0]?.filial || "c511a33d-6b85-4cdf-88af-6a221f0eb46d",
                    //serie: response.data[0].serie,
                    numero: response.data.retorno.numeroNfse,
                    chaveAcesso: response.data.retorno.codigoVerificacao,
                    tipo: nfInfo?.tipoNotaFiscal == 'Nota_Fiscal' ? 'Venda' : this.optionTypeNf == 'Nota_Fiscal_de_Remessa' ? 'Remessa' : 'Serviço',
                    destino: this.optionTypeNf != 'Nota Fiscal de Remessa' ? 'Cliente' : 'Fornecedor',
                    dataEmissao: moment(nfInfo.notaFiscalServico[0]?.dataEmissao || nfInfo.notaFiscalServico[0]?.createAt).format('YYYY-MM-DD'),
                    dataSaida: moment(nfInfo.notaFiscalServico[0].dataSaida).format('YYYY-MM-DD'),
                    cliente: nfInfo?.destinatario || undefined,
                    fornecedor: nfInfo?.destinatarioFornecedor || undefined,
                    cfop: undefined,
                    notaFiscalValor: Number(nfInfo.valueNf),
                    valorFinanceiro: Number(nfInfo.valueNf),
                    parcelas: fisDocEmiFinIds,
                    plugNotasId: id,
                    statusEmissao: "EMITIDA",
                    transportadora: undefined,
                    descontoValor: 0,
                    freteValor: 0,
                    outroValor: 0,
                    produtoValor: nfInfo.notaFiscalServico[0].valorUnitario,
                    ipiValor: nfInfo.notaFiscalServico[0].ipi,
                    icmsValor: nfInfo.notaFiscalServico[0].icms,
                    pisValor: nfInfo.notaFiscalServico[0].pis,
                    cofinsValor: nfInfo.notaFiscalServico[0].confins,
                    tipoFrete: undefined
                })

                finRecCad.map((item) => {
                    delete item.createBy
                    item.notaFiscalEmitida = responseFisDocEmi.data.data.id
                    return item
                })

                if(finRecCad.length > 0) await Vue.prototype.$http.put('/entity/updateMany/FinRec', finRecCad)

            }

            this.$notfy.success(`Nota Fiscal Atualizada com status ${response.data.status}.`)
            await this.getIssuanceInvoices()
        },

        async resumoNotaFiscal(nfInfo, options = {}){
            console.log('nfInfo >>> ', JSON.parse(nfInfo?.plugNotasResponse))
            this.$notfy.warning(`Gerando o resumo da nota fiscal.`)
            let plugResponse = JSON.parse(nfInfo?.plugNotasResponse)
            let idIntegracao = plugResponse?.documents?.[0] ? plugResponse?.documents[0]?.idIntegracao : plugResponse[0]?.idIntegracao
            const fallbackStatusNf = options?.fallbackStatusNf || nfInfo?.statusNf || 'Processando'
            const fallbackStatusPreNota = options?.fallbackStatusPreNota || nfInfo?.notaFiscal?.[0]?.statusEmissao || ''

            let ipiTotal = 0
            let totalPis = 0;
            let totalCofins = 0;
            let totalIcms = 0;
            let totalValorFrete = 0
            let totalValorSeguro = 0
            let totalValorOutros = 0
            let totalValorDeconto = 0


            let url = '';
            //let emitente = plugResponse.documents[0]?.Emitente;
            url = `${this.baseUrl}/nfe/02823203000103/${idIntegracao}/resumo`;

            const response = await axios.get(url, {
                headers: {
                    'X-API-KEY': this.apiKey,
                    'Content-Type': 'application/json',
                },
            });

            console.log('resumo >>> ', response, nfInfo)
            const statusResumo = String(response?.data?.[0]?.status || '').trim().toUpperCase()
            const chaveAcessoResumo = statusResumo === 'PENDENTE'
                ? undefined
                : (response?.data?.[0]?.chave || nfInfo?.chaveAcesso || undefined)

            const objEmissao = await this.mergeEntityPayload('EmissaoNotasFiscais', nfInfo._id, {
                plugNotasID: nfInfo.plugNotasID,
                plugNotasMensagem: response.data[0].mensagem,
                plugNotaIdIntegracao: response.data[0].plugNotaIdIntegracao,
                tipoNotaFiscal: nfInfo.tipoNotaFiscal?.replaceAll('_', ' '),
                destinatario: nfInfo.destinatario || undefined,
                destinatarioFornecedor: nfInfo.destinatarioFornecedor || undefined,
                statusNf: this.getResumoInvoiceStatus(response.data[0].status, fallbackStatusNf),
                plugNotasResponse: JSON.stringify(response.data),
                chaveAcesso: chaveAcessoResumo,
                notaFiscalDeRemessa: nfInfo.notaFiscalDeRemessa
            })

            if (statusResumo === 'PENDENTE') {
                delete objEmissao.chaveAcesso
            }

            const statusPreNotaResumo = this.getResumoPreNotaStatus(response.data[0].status, fallbackStatusPreNota)

            const objPreNota = await this.mergeEntityPayload('FisPreDocEmi', nfInfo.notaFiscal[0]._id, {
                statusEmissao: statusPreNotaResumo,
                plugNotasID: nfInfo.plugNotasID,
                plugNotasMensagem: response.data[0].mensagem
            })

            const requisicoesResumo = [
                Vue.prototype.$http.put('/Entity/EmissaoNotasFiscais', objEmissao),
                Vue.prototype.$http.put('/Entity/FisPreDocEmi', objPreNota)
            ]

            requisicoesResumo.push(
                this.atualizarStatusFisDocEmiPorInfo(nfInfo, statusPreNotaResumo)
            )

            await Promise.all(requisicoesResumo)

            if (['REJEITADO', 'REJEITADA'].includes(String(response.data[0].status || '').toUpperCase())) {
                this.openRejectionReasonModal(response.data[0].mensagem)
            }

            if(response.data[0].status == "CONCLUIDO"){

                // Itens FisDocRecItem
                const responseItens = await Vue.prototype.$http.get('/Entity/FisPreDocEmiItem/search-fields', {
                    params: {
                        ids: nfInfo.notaFiscal[0].itens.map((item) => item ).join(',')
                    }
                })

                let fisDocEmiItens = responseItens.data.data.data.map((fisEmiItem, index) => {

                    delete fisEmiItem.createAt
                    delete fisEmiItem.updateAt
                    delete fisEmiItem.createBy
                    delete fisEmiItem.updateBy
                    delete fisEmiItem.deleteAt
                    delete fisEmiItem.deleteBy
                    delete fisEmiItem.isDeleted
                    delete fisEmiItem.ipiCompoeBaseCalculo
                    delete fisEmiItem.freteCompoeBaseCalculo

                    ipiTotal += fisEmiItem.ipiValor / 100
                    totalPis += fisEmiItem.pisValor / 100
                    totalCofins += fisEmiItem.cofinsValor / 100
                    totalIcms += fisEmiItem.icmsValor / 100

                    totalValorFrete += Number(fisEmiItem.valorFrete / 100)
                    totalValorSeguro += Number(fisEmiItem.valorSeguro / 100)
                    totalValorOutros += Number(fisEmiItem.valorOutros / 100)
                    totalValorSeguro += Number(fisEmiItem.valorSeguro / 100)


                    return {
                        ...fisEmiItem,
                        sequencia: index + 1,
                        ipiBaseCalculo: fisEmiItem.ipiBaseCalculo / 100,
                        valorUnitario: fisEmiItem.valorUnitario / 100,
                        valorTotal: fisEmiItem.valorTotal / 100,
                        pisValor: fisEmiItem.pisValor / 100,
                        ipiPercentual: fisEmiItem.ipiPercentual,
                        ipiValor: fisEmiItem.ipiValor / 100,
                        pisBaseCalculo: fisEmiItem.pisBaseCalculo / 100,
                        cofinsBaseCalculo: fisEmiItem.cofinsBaseCalculo / 100,
                        resultBaseCalcICMS: fisEmiItem.resultBaseCalcICMS / 100,
                        icmsPercentual: String(fisEmiItem.icmsPercentual),
                        icmsBaseCalculo: fisEmiItem.icmsBaseCalculo / 100,
                        icmsValor: fisEmiItem.icmsValor / 100,
                        cofinsValor: fisEmiItem.cofinsValor / 100,
                        itemDescription: undefined,
                        id: undefined,
                        ctsIpi: undefined
                    }

                })

                const responseFisPreDocEmiItem = await Vue.prototype.$http.post('/Entity/insertMany/FisDocEmiItem', fisDocEmiItens)

                let fisDocEmiIds = responseFisPreDocEmiItem?.data?.data?.map((item) => {
                    return item.id
                })

                // Fim



                let fisDocEmiFinIds = []
                let fisDocRecFinS = []
                let finRecCad = []

                if(nfInfo.notaFiscal[0].parcelas?.length  > 0 && nfInfo.tipoNotaFiscal == 'Nota_Fiscal'){

                    const responseParcelas = await Vue.prototype.$http.get('/Entity/FisPreDocEmiFin/search-fields', {
                        params: {
                            ids: nfInfo.notaFiscal[0].parcelas.map((item) => item ).join(',')
                        }
                    })

                    const parcelas = responseParcelas?.data?.data?.data

                    let objItensFinRec = []
                    if (!nfInfo.notaFiscalDeRemessa || !this.isCfopsNfMae.includes(nfInfo.notaFiscal[0].cfop)) {
                        if (parcelas?.length > 0) {
                            parcelas.forEach((p, index) => {
                                objItensFinRec.push({
                                    status: "Prevista",
                                    origem: "Nota Fiscal Emitida",
                                    parcela: index + 1,
                                    preNota: nfInfo.notaFiscal[0]._id,
                                    job: nfInfo.notaFiscal[0].job,
                                    cliente: nfInfo.destinatario,
                                    valorOriginal: p.vlr / 100,
                                    valorRecebido: 0,
                                    valorSaldo: p.vlr / 100,
                                    dataCriacao:  moment().format("YYYY-MM-DD"),
                                    dataVencimento: p.dtPag
                                        ? moment(new Date(p.dtPag)).format("YYYY-MM-DD")
                                        : moment(new Date(nfInfo.notaFiscal[0].dataSaida)).format("YYYY-MM-DD"),
                                    descricao: "Gerado pela pré-nota " + nfInfo.notaFiscal[0].codigo,
                                    observacao: "",
                                });
                            });

                            const responseInsertFinRec = await Vue.prototype.$http.post("/Entity/insertMany/FinRec", objItensFinRec)
                            finRecCad = responseInsertFinRec.data.data

                        } else {

                            await Vue.prototype.$http.post("/Entity/FinRec", {
                                origem: "Nota Fiscal Emitida",
                                status: "Prevista",
                                parcela: nfInfo.notaFiscal[0].parcelas?.length || 1,
                                preNota: nfInfo.notaFiscal[0]._id,
                                job: nfInfo.notaFiscal[0].job,
                                cliente: nfInfo.destinatario,
                                valorOriginal: Number(nfInfo.valueNf),
                                dataVencimento: moment(nfInfo.notaFiscal[0].dataSaida).format('YYYY-MM-DD'),
                                dataCriacao:  moment().format("YYYY-MM-DD"),
                                //notaFiscalEmitida: responseFisPreDocEmi.data.data.id,
                                descricao: "Gerado pela pré-nota " + nfInfo.notaFiscal[0].codigo,
                                observacao: "",
                               // notaFiscalEmitida: responseFisDocEmi.data.data.id
                            })
                        }
                    }

                    fisDocRecFinS = responseParcelas?.data?.data?.data?.map((item, index) => {

                        delete item.createAt
                        delete item.updateAt
                        delete item.createBy
                        delete item.updateBy
                        delete item.deleteAt
                        delete item.deleteBy
                        delete item.isDeleted
                        delete item.id

                        return {
                            ...item,
                            vlr: item.vlr / 100,
                            contaAReceber: finRecCad[index]?.id
                        }
                    })

                    //FisDocEmiFin
                    const responseFisPreDocEmiItem = await Vue.prototype.$http.post('/Entity/insertMany/FisDocEmiFin', fisDocRecFinS)

                    fisDocEmiFinIds = responseFisPreDocEmiItem?.data?.data?.map((item) => {
                        return item.id
                    })

                }

                const tipoFrete = nfInfo.notaFiscal[0]?.project[0]?.freteTipo;

                const resultTipoFrete = tipoFrete
                    ?.replaceAll('_', ' ')
                    ?.replace(/\s+/g, ' ')
                    ?.trim();

                //console.log('resultTipoFrete ', resultTipoFrete, nfInfo.notaFiscal[0]?.project[0].freteTipo)

                const responseFisDocEmi = await Vue.prototype.$http.post('/Entity/FisDocEmi', {
                    job: nfInfo.notaFiscal[0].job,
                    preNota: nfInfo.notaFiscal[0]._id,
                    filial: nfInfo.notaFiscal[0].filial,
                    serie: response.data[0].serie,
                    numero: response.data[0].numero,
                    chaveAcesso: response.data[0].chave,
                    tipo: nfInfo?.tipoNotaFiscal == 'Nota_Fiscal' ? 'Venda' : this.optionTypeNf == 'Nota_Fiscal_de_Remessa' ? 'Remessa' : 'Serviço',
                    destino: this.optionTypeNf != 'Nota Fiscal de Remessa' ? 'Cliente' : 'Fornecedor',
                    dataEmissao: moment(nfInfo.notaFiscal[0]?.dataEmissao || nfInfo.notaFiscal[0]?.createAt).format('YYYY-MM-DD'),
                    dataSaida: moment(nfInfo.notaFiscal[0].dataSaida).format('YYYY-MM-DD'),
                    cliente: nfInfo?.destinatario || undefined,
                    fornecedor: nfInfo?.destinatarioFornecedor || undefined,
                    cfop:  "",
                    notaFiscalValor: Number(nfInfo.valueNf) // subtotal dos produtos (vProd)
                        - (totalValorDeconto || 0) // desconto
                        + (totalValorFrete  || 0)    // frete
                        + (totalValorOutros  || 0)   // outras despesas
                        + (totalValorSeguro  || 0)  // seguro
                        + ipiTotal,                                     // IPI entra
                        // + totalIcmsST,
                    valorFinanceiro: Number(nfInfo.valueNf),
                    itens: fisDocEmiIds,
                    parcelas: fisDocEmiFinIds,
                    plugNotasId: response.data[0].id,
                    statusEmissao: "EMITIDA",
                    transportadora: nfInfo.notaFiscal[0]?.transportadora || nfInfo.notaFiscal[0]?.project?.transportadora || undefined,
                    descontoValor: totalValorDeconto || 0,
                    freteValor: totalValorFrete,
                    outroValor: totalValorOutros,
                    produtoValor: Number(nfInfo.valueNf),
                    seguroValor: totalValorSeguro || undefined,
                    informacoesAdicionais: nfInfo.notaFiscal[0]?.project[0]?.informacoesAdicionais || undefined,
                    //freteTipo: nfInfo.notaFiscal[0].project[0]?.freteTipo.replaceAll("_", ' ') || undefined,
                    volumeQuantidade: nfInfo.notaFiscal[0]?.volumeQuantidade || undefined,
                    volumeTipo: nfInfo.notaFiscal[0].project[0]?.volumeTipo || undefined,
                    pesoBruto: nfInfo.notaFiscal[0]?.pesoBruto || undefined,
                    pesoLiquido: nfInfo.notaFiscal[0]?.pesoLiquido || undefined,
                    //Impostos
                    valorBaseDeCalculo: nfInfo.notaFiscal[0].valorBaseDeCalculo,
                    ipiValor: ipiTotal,
                    icmsValor: totalIcms,
                    pisValor: totalPis,
                    cofinsValor: totalCofins,
                    tipoFrete: nfInfo.notaFiscal[0]?.tipoFrete || resultTipoFrete|| undefined,
                    meioPagamento: nfInfo.notaFiscal[0]?.meioPagamento.replaceAll('_', ' ') || undefined
                })

                const fisDocEmiId = responseFisDocEmi?.data?.data?.id || responseFisDocEmi?.data?.data?._id
                if (!fisDocEmiId) {
                    throw new Error('A nota foi confirmada, mas não foi possível criar o registro da nota fiscal emitida.')
                }

                await this.vincularFisDocEmiAosRomaneios(
                    nfInfo.notaFiscal[0]?.romaneio,
                    fisDocEmiId
                )

                if (['Nota_Fiscal', 'Nota_Fiscal_de_Remessa'].includes(nfInfo.tipoNotaFiscal)) {
                    await SaidaEstoqueNotaFiscalService.realizarSaida({
                        notaFiscalEmitida: fisDocEmiId,
                        numeroNotaFiscal: response.data[0].numero,
                        itens: responseItens.data.data.data
                    })
                }

                //console.log('responseFisPreDocEmi >>> ', nfInfo.notaFiscal[0].project[0].tranportadora[0]?._id, responseFisPreDoc

                if(nfInfo.tipoNotaFiscal == 'Nota_Fiscal'){
                    finRecCad.map((item) => {
                        delete item.createBy
                        item.notaFiscalEmitida = responseFisDocEmi.data.data.id
                        return item
                    })

                   if(finRecCad.length > 0) await Vue.prototype.$http.put('/entity/updateMany/FinRec', finRecCad)
                }

            }

            this.$notfy.success(`Nota Fiscal Atualizada com status ${response.data[0].status}.`)
            await this.getIssuanceInvoices()

        },

        async previeNf(nfInfo) {

            if(nfInfo.tipoNotaFiscal == 'Nota_Fiscal_de_Serviço'){
                this.openPreviewNfServico = true
                this.previewNf = nfInfo
                return
            }

            const payload = await this.emitirPreviewNotaFiscal(nfInfo, false)

            console.log('nfInfo ', payload)

            //const payload = JSON.parse(nfInfo.plugNotasResponse)[0] || JSON.parse(nfInfo.plugNotasResponse)


            this.$notfy.warning(`Gerando a pré-visualização da nota fiscal.`)

            await new Promise(r => setTimeout(r, 5000));


            const response = await axios.get(`https://api.plugnotas.com.br/nfe/${payload?.protocol || ""}/preview`,{
                responseType: 'arraybuffer',
                responseEncoding: 'binary',
                ContentType: 'application/pdf', 
                headers:{
                    "Content-Type": 'application/json',
                    "x-api-key": "5bbf2aa2efee08a50be2cefaf8ab8811"
                },
                
            })
            
            const buffer = Buffer.from(response.data);
            const base64Pdf = buffer.toString('base64');

            this.previewNf = base64Pdf;
            this.openPreview = true;

        },
        
        async emitirPreviewNotaFiscal(nfInfo) {

            this.$notfy.warning("Gerando...")

            const nfData = await this.createObjectEmissao(nfInfo)

            try {
                const response = await axios.post(
                    'https://api.plugnotas.com.br/nfe/preview',
                    nfData,
                    {
                        headers: {
                            'X-API-KEY': "5bbf2aa2efee08a50be2cefaf8ab8811",
                            'Content-Type': 'application/json'
                        }
                    }
                );

                console.log('NF enviada com sucesso!');
                //this.$notfy.success("Nota Fiscal Gerada com sucesso.")

                return response.data;

            } catch (error) {
                const apiError = error?.response?.data;

                console.log('apiError >>> ', apiError)

                if (apiError && apiError.error && apiError.error.message === 'Falha na validação do JSON de Prévia da DANFe') {
                    const fields = apiError.error.data && apiError.error.data.fields ? apiError.error.data.fields : {};

                    const detailList = Object.keys(fields).length
                        ? Object.entries(fields).map(([field, msg]) => `${field}: ${msg}`)
                        : [];

                    this.errorValidationTitle = 'Falha na validação da prévia da DANFe';
                    this.errorValidationMessages = detailList;
                    this.errorValidationDialog = true;
                } else {
                    this.$notfy.error('Erro ao emitir NF: ' + (apiError?.message || error.message));
                }

                console.error('Erro ao emitir NF:', error.response?.data || error.message);
            }

        },

        async emitirNotaFiscal(nfInfo) {

            if(this.errorValidationDialog) return

            this.$notfy.warning("Gerando...")

            const nfData = await this.createObjectEmissao(nfInfo)

            try {
                const response = await axios.post(
                    'https://api.plugnotas.com.br/nfe',
                    [ nfData ],
                    {
                        headers: {
                            'X-API-KEY': this.apiKey,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                console.log('NF enviada com sucesso!');
                this.$notfy.success("Nota Fiscal Gerada com sucesso.")
                
                const idIntegracao = response.data.documents[0]?.idIntegracao
                const idPlugNota = response.data.documents[0]?.id
                const menssage = response.data?.message

                const objEmissao = {
                    plugNotasID: idPlugNota,
                    plugNotasMensagem: menssage,
                    plugNotaIdIntegracao: idIntegracao,
                    tipoNotaFiscal: nfInfo.tipoNotaFiscal?.replaceAll('_', ' '),
                    destinatario: nfInfo.destinatario || undefined,
                    destinatarioFornecedor: nfInfo.destinatarioFornecedor || undefined,
                    statusNf: "Processando",
                    notaFiscal: nfInfo.notaFiscal[0]._id,
                    valueNf: Number(nfInfo.valueNf),
                    id: nfInfo._id,
                    plugNotasResponse: JSON.stringify(response.data),
                    notaFiscalDeRemessa: nfInfo.notaFiscalDeRemessa
                }

                const responseItens = await Vue.prototype.$http('/Entity/FisPreDocEmiItem/search-fields',  {
                    params: {
                        ids: nfInfo.notaFiscal[0].itens.map((id) => id).join(',')
                    }
                })

                const itens = responseItens.data.data.data
                console.log('responseItens >>>> ', itens)

                let sumBaseCalculo = 0
                let sumIpi = 0
                let sumCofins = 0
                let sumPis = 0
                let sumIcms = 0

                itens.map((item) => {
                    sumBaseCalculo += (Number(item.ipiBaseCalculo) / 100 + Number(item.icmsBaseCalculo) / 100 + Number(item.pisBaseCalculo) / 100 + Number(item.cofinsBaseCalculo) / 100)
                    sumIpi += Number(item.ipiValor) / 100
                    sumCofins += Number(item.cofinsValor) / 100
                    sumPis += Number(item.pisValor) / 100
                    sumIcms += Number(item.icmsValor) / 100
                })

                console.log('sumBaseCalculo >>> ', sumBaseCalculo)

                await Promise.all([
                    Vue.prototype.$http.put('/Entity/EmissaoNotasFiscais', objEmissao),
                    Vue.prototype.$http.put('/Entity/FisPreDocEmi', {
                        id: nfInfo.notaFiscal[0]._id,
                        codigo: nfInfo.notaFiscal[0].codigo,
                        addRetirada: nfInfo.notaFiscal[0].addRetirada,
                        statusEmissao: "PROCESSANDO",
                        plugNotasID: idPlugNota,
                        plugNotasMensagem: menssage,
                        filial: nfInfo.notaFiscal[0].filial,
                        job: nfInfo.notaFiscal[0]?.job || undefined,
                        romaneio: nfInfo.notaFiscal[0]?.romaneio || undefined,
                        cliente: nfInfo.destinatario || undefined,
                        fornecedor: nfInfo.destinatarioFornecedor || undefined,
                        cnpj: nfInfo.notaFiscal[0].cnpj,
                        dataEmissao: nfInfo.notaFiscal[0].dataEmissao,
                        naturezaOperacao: nfInfo.notaFiscal[0].naturezaOperacao,
                        defFiscais: nfInfo.notaFiscal[0].defFiscais || undefined,
                        condicaoPagamento: nfInfo.notaFiscal[0].condicaoPagamento,
                        destinatarioCep: nfInfo.notaFiscal[0].destinatarioCep,
                        destinatarioCidade: nfInfo.notaFiscal[0].destinatarioCidade,
                        destinatarioLogradouro: nfInfo.notaFiscal[0].destinatarioLogradouro,
                        destinatarioNumero: nfInfo.notaFiscal[0].destinatarioNumero,
                        destinatarioBairro: nfInfo.notaFiscal[0].destinatarioBairro,
                        codigoCidade: nfInfo.notaFiscal[0].codigoCidade,
                        uf: nfInfo.notaFiscal[0].uf,
                        email: nfInfo.notaFiscal[0].email,
                        notaFiscalMae: nfInfo.notaFiscal[0].notaFiscalMae || undefined,
                        itens: nfInfo.notaFiscal[0].itens || [],
                        parcelas: nfInfo.notaFiscal[0].parcelas || [],
                        dataSaida: nfInfo.notaFiscal[0].dataSaida,
                        //
                        seguroValor: nfInfo.notaFiscal[0]?.project[0]?.tranportadora[0]?.seguroValor || undefined,
                        informacaoAdd: nfInfo.notaFiscal[0]?.informacaoAdd,
                        informacoesAdicionais: nfInfo.notaFiscal[0]?.project[0]?.tranportadora[0]?.informacoesAdicionais || undefined,
                        //freteTipo: nfInfo.notaFiscal[0]?.project[0]?.tranportadora[0]?.replaceAll("_", ' ') || undefined,
                        //volumeQuantidade: nfInfo.notaFiscal[0]?.project[0]?.tranportadora[0]?.volumeQuantidade || undefined,
                        volumeTipo: nfInfo.notaFiscal[0]?.project[0]?.tranportadora[0]?.volumeTipo || undefined,
                        //pesoBruto: nfInfo.notaFiscal[0]?.project[0]?.tranportadora[0]?.pesoBruto || undefined,
                        //pesoLiquido: nfInfo.notaFiscal[0]?.project[0]?.tranportadora[0]?.pesoLiquido || undefined,
                        valorBaseDeCalculo: sumBaseCalculo,
                        ipiValor: sumIpi,
                        icmsValor: sumIcms,
                        pisValor: sumPis,
                        cofinsValor: sumCofins,
                        transportadora: nfInfo.notaFiscal[0]?.transportadora,
                        volumeQuantidade: Number(nfInfo.notaFiscal[0].volumeQuantidade),
                        especie: nfInfo.notaFiscal[0].especie,
                        marca: nfInfo.notaFiscal[0].marca,
                        volumeNumeracao: nfInfo.notaFiscal[0].numeracao,
                        pesoBruto: nfInfo.notaFiscal[0].pesoBruto,
                        pesoLiquido: nfInfo.notaFiscal[0].pesoLiquido,
                        valorFrete: nfInfo.notaFiscal[0].valorFrete,
                        valorSeguro: nfInfo.notaFiscal[0].valorSeguro,
                        valorDesconto: nfInfo.notaFiscal[0].valorDesconto,
                        valorOutros: nfInfo.notaFiscal[0].valorOutros,
                        ncm: nfInfo.notaFiscal[0].ncm,
                        cest: nfInfo.notaFiscal[0].cest || undefined,
                        cfop: nfInfo.notaFiscal[0].cfop || undefined,
                        fisOper: nfInfo.notaFiscal[0].operacaoFiscal,
                        codigoBeneficioFiscal: nfInfo.notaFiscal[0]?.codigoBeneficioFiscal || undefined,
                        meioPagamento: nfInfo.notaFiscal[0].meioPagamento.replaceAll('_', ' ') || undefined,
                    })
                ])

                await this.getIssuanceInvoices()

            } catch (error) {
                this.$notfy.error("Erro ao emitir NF: ", error.response?.data || error.message)
                console.error('Erro ao emitir NF:', error.response?.data || error.message);
            }
        },

        async emitirNotaFiscalServico(infoNf){
            this.$notfy.warning("Gerando...")
            console.log('emitirNotaFiscalServico ', infoNf)
            // baseUrl: 'https://api.sandbox.plugnotas.com.br', // 'https://api.plugnotas.com.br',
            // apiKey: '2da392a6-79d2-4304-a8b7-959572c7e44d', // '21c94f51-ca20-4ba0-a6d2-ffc23291680c',

            let parcelasIds = infoNf.notaFiscalServico[0].parcelas || []
            let parcelas = []

            if(parcelasIds.length > 0){
                const responseParcelas = await Vue.prototype.$http.get('/Entity/FisPreDocEmiFin/search-fields', {
                    params: {
                        ids: parcelasIds.map((item) => item ).join(','),
                    }
                })

                responseParcelas.data.data.data.map((item, index) => {
                    parcelas.push({
                        "numero": (index + 1).toString().padStart(3, '0'),
                        "tipoPagamento": 5,
                        "dataVencimento": item.dtPag,
                        "valorParcela": Number((item.vlr / 100).toFixed(2))
                    })
                })
            }
            
            let servico = infoNf.notaFiscalServico[0]?.jobItensList.map((item) => {
                return {
                    "codigo": infoNf.notaFiscalServico[0].enquadramentoServicoCodigo?.replace(/\D/g, ''),
                    "codigoTributacao": infoNf.notaFiscalServico[0].enquadramentoServicoCodigo,
                    "discriminacao": item?.descricao,
                    "cnae": infoNf.notaFiscalServico[0]?.cnaeCodigo?.replace(/\D/g, ''),
                    "iss": {
                        "tipoTributacao": 7,
                        "exigibilidade": 1,
                        "aliquota": 2
                    },
                    "valor": {
                        "liquido": infoNf.notaFiscalServico[0].vlrLiquido / 100,
                        "baseCalculo": infoNf.notaFiscalServico[0].baseCalculo || infoNf.valueNf,
                        "servico": item.precoTotal || infoNf.valueNf,
                        "descontoCondicionado": 0,
                        "descontoIncondicionado": 0
                    },
                    "retencao": {
                        "pis": {
                            "valor": infoNf.notaFiscalServico[0].vlrPIS / 100 || undefined
                        },
                        "cofins": {
                            "valor": infoNf.notaFiscalServico[0].vlrCOFINS / 100 || undefined
                        },
                        "csll": {
                            "valor": infoNf.notaFiscalServico[0].vlrSCLL / 100 || undefined
                        },
                        "inss": {
                            "valor": infoNf.notaFiscalServico[0].vrlINSS / 100 || undefined
                        },
                        "irrf": {
                            "valor": infoNf.notaFiscalServico[0].vlrIR / 100 || undefined
                        }
                    }
                }
            })

            const nfData = [
                {
                    "lote": 2,
                    "idIntegracao": `${Math.floor(10000000 + Math.random() * 90000000)}`,
                    "naturezaOperacao": 1,
                    "optanteSimplesNacional": false,
                    "incentivadorCultural": false,
                    "regimeEspecialTributacao": 0,
                    "status": 1,
                    "rps": {
                        "dataEmissao": new Date(),
                        "envioSincrono": true
                    },
                    "prestador": {
                        "cpfCnpj": infoNf.notaFiscalServico[0].emitenteCpfOrCnpj?.replace(/\D/g, ''),
                        "inscricaoMunicipal": infoNf.notaFiscalServico[0].emitenteIm,
                        "nomeFantasia": infoNf.notaFiscalServico[0].emitenteRazaoSocial,
                        "endereco": {
                            "codigoCidade": infoNf.notaFiscalServico[0].emitenteCodCidade || '3539103',
                            "estado": "SP",
                            "bairro": infoNf.notaFiscalServico[0].emitenteBairro,
                            "descricaoCidade": infoNf.notaFiscalServico[0].emitenteLocalEmissao,
                            "logradouro": infoNf.notaFiscalServico[0].emitenteLogradouro,
                            "numero": "",
                            "cep": "06550000"
                        }
                    },
                    "tomador": {
                        "cpfCnpj": infoNf.notaFiscalServico[0].tomadorCpfOrCnpj?.replace(/\D/g, ''),
                        "razaoSocial": infoNf.notaFiscalServico[0].tomadorCpfOrCnpj.tomadorRazaoSocial,
                        "inscricaoMunicipal": infoNf.notaFiscalServico[0]?.tomadorIm || undefined,
                        "email": infoNf.notaFiscalServico[0]?.tomadorEmail,
                        "endereco": {
                            "codigoCidade": infoNf.notaFiscalServico[0]?.codigoCidade?.replace(/\D/g, ''),
                            "descricaoCidade": infoNf.notaFiscalServico[0].tomadorEndereco.split('-')[0].split('Cidade:')[1].trim(''),
                            "logradouro": infoNf.notaFiscalServico[0].tomadorEndereco.split('-')[1].split('Rua:')[1].trim(''),
                            "estado": infoNf.notaFiscalServico[0].tomadorUf,
                            "utilizarDadosTomador": false,
                            "numero": infoNf.notaFiscalServico[0].tomadorNumero, //"21",
                            "bairro": infoNf.notaFiscalServico[0].tomadorEndereco.split('-')[2].split('Bairro:')[1].trim(''),
                            "cep": infoNf.notaFiscalServico[0].tomadorCep?.replace(/\D/g, ''),
                        }
                    },
                    "parcelas": parcelas,
                    "servico": servico
                }
            ]



            try {
                const response = await axios.post(
                    'https://api.plugnotas.com.br/nfse',
                    nfData,
                    {
                        headers: {
                            'X-API-KEY': this.apiKey,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                console.log('response >>> ', response.data.documents[0])

                const idIntegracao = response.data.documents[0]?.idIntegracao
                const idPlugNota = response.data.documents[0]?.id
                const menssage = response?.message

                const objEmissao = {
                    plugNotasID: idPlugNota,
                    plugNotasMensagem: menssage,
                    plugNotaIdIntegracao: idIntegracao,
                    tipoNotaFiscal: infoNf.tipoNotaFiscal.replaceAll('_', ' '),
                    destinatario: infoNf.destinatario,
                    statusNf: "Processando",
                    notaFiscalServico: infoNf.notaFiscalServico[0]._id,
                    valueNf: Number(infoNf.valueNf),
                    id: infoNf._id,
                    plugNotasResponse: JSON.stringify(response.data),
                    chaveAcesso: response.data.documents[0]?.chave
                }

                await Promise.all([
                    Vue.prototype.$http.put('/Entity/EmissaoNotasFiscais', objEmissao),
                    Vue.prototype.$http.put('/Entity/FisDocService', {
                        ...infoNf.notaFiscalServico[0],
                        id: infoNf.notaFiscalServico[0]._id,
                        _id: undefined,
                        jobItensList: undefined,
                        status: "Processando",
                        emitenteTipoEnquadramento: infoNf.notaFiscalServico[0].emitenteTipoEnquadramento || '',
                        tomadorIm: infoNf.notaFiscalServico[0].tomadorIm || '',
                        fornecedor: infoNf.notaFiscalServico[0].fornecedor || '',
                        cnpj: infoNf.notaFiscalServico[0].emitenteCpfOrCnpj || '',
                        numero: infoNf.notaFiscalServico[0].numero || '',
                        pedido: infoNf.notaFiscalServico[0].pedido || '',
                        pdf: infoNf.notaFiscalServico[0].pdf || undefined,
                        reasoning: infoNf.notaFiscalServico[0].reasoning || '',
                        codigoCidade: infoNf.notaFiscalServico[0].codigoCidade || '',
                        jobItens: infoNf.notaFiscalServico[0].jobItens,
                        tributacao: undefined,
                        cnae: infoNf.notaFiscalServico[0].cnae || undefined,
                        cnaeCodigo: infoNf.notaFiscalServico[0]?.cnaeCodigo || undefined,
                        cnaeDescricao: infoNf.notaFiscalServico[0].cnaeDescricao || undefined,
                        tributacaoMunicipal: infoNf.notaFiscalServico[0].tributacaoMunicipal || undefined,
                        regimeTributario: infoNf.notaFiscalServico[0].regimeTributario || undefined,
                        regimeTributarioCodigo: infoNf.notaFiscalServico[0].regimeTributarioCodigo || undefined,
                        regimeTributarioDescricao: infoNf.notaFiscalServico[0].regimeTributarioDescricao || undefined,
                        enquadramentoServico: infoNf.notaFiscalServico[0].enquadramentoServico || undefined,
                        enquadramentoServicoCodigo: infoNf.notaFiscalServico[0].enquadramentoServicoCodigo || undefined,
                        enquadramentoServicoDescricao: infoNf.notaFiscalServico[0].enquadramentoServicoDescricao || undefined,
                        emitenteCnae: infoNf.notaFiscalServico[0].emitenteCnae || undefined,
                        emitenteCodCidade: infoNf.notaFiscalServico[0].emitenteCodCidade || undefined
                    })
                ])

                console.log('NF enviada com sucesso!', response.data);
                this.$notfy.success("Nota Fiscal de Serviço Gerada com sucesso.")

                await this.getIssuanceInvoices()

            } catch (error) {
                this.$notfy.error("Erro ao emitir NF: ", error.response?.data || error.message)
                console.error('Erro ao emitir NF:', error.response?.data || error.message);
            }
        },
        
        sanitizeDescricao(text) {
            return text
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/\r?\n|\r/g, " ")
                .replace(/[^A-Za-z0-9\s\-.,/]/g, "");
        },

        getCodigoTributario(value, fallback = "") {
            if (value === null || value === undefined) return fallback;

            const texto = String(value).trim();
            if (!texto.length) return fallback;

            const codigo = texto.split(" - ")[0].trim();
            return codigo || fallback;
        },

        normalizeCodigoCidade(value, descricaoCidade = '') {
            const codigo = String(value || '').replace(/\D/g, '');
            const cidade = String(descricaoCidade || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .trim()
                .toUpperCase();

            if (codigo === '352940' && cidade === 'MAUA') return '3529401';
            return codigo;
        },

        async createObjectEmissao(nfInfo) {

            console.log('nfInfo ', nfInfo)


            let romaneiosNfInfo = nfInfo.notaFiscal[0]?.romaneio
            let parcelas = nfInfo.notaFiscal[0]?.parcelas
            let fisPreDocEmiItem = nfInfo.notaFiscal[0]?.itens
            let itens = []
            let sum = 0

            let fisPreDocEmiFin = [];
            let parcelasFormatadas = [];
            let valorLiquido = 0;
            let totalCobranca = 0;

            const normalizePlugNotasNumericField = (value, fallback = '') => {
                const normalized = String(value ?? fallback ?? '')
                    .replace(/\D/g, '');

                return normalized || String(fallback ?? '').replace(/\D/g, '');
            }

            if (parcelas?.length > 0 && !nfInfo.notaFiscalDeRemessa) {
                const parcelasResponse = await Vue.prototype.$http.get('/Entity/FisPreDocEmiFin/search-fields', {
                    params: {
                        ids: parcelas.map((id) => id).join(','),
                        sortField: 'parcelaSequencia'
                    }
                })

                fisPreDocEmiFin = parcelasResponse.data.data.data

                // Cria array de parcelas formatadas e soma valores
                parcelasFormatadas = fisPreDocEmiFin.reduce((acc, p) => {
                    acc.push({
                        dataVencimento: new Date(p.dtPag),
                        numero: `00${p.parcelaSequencia}`,
                        tipoPagamento: 1,
                        valor: p.vlr / 100
                    });
                    valorLiquido += p.vlr / 100;
                    totalCobranca += p.vlr / 100;
                    return acc;
                }, []);
            }

            let romaneios = []
            if(romaneiosNfInfo?.length > 0){
                const romaneioResponse = await Vue.prototype.$http.get('/Entity/Romaneio/search-fields', {
                    params: {
                        ids: romaneiosNfInfo.map((id) => id).join(','),
                    }
                })

                romaneios = romaneioResponse.data.data.data
            }

            const cfopNota = String(nfInfo.notaFiscal[0]?.cfop || '').trim()
            const exigirIcmsRemessa = nfInfo.notaFiscalDeRemessa && ['5901', '6901'].includes(cfopNota)

            let localRetirada = {}
            let isRetiradaAndEntrega = nfInfo.notaFiscal[0]?.addRetirada == true
            if(isRetiradaAndEntrega){

                const response = await Vue.prototype.$http.post('/Action/run', 
                    { 
                        actionId: "128f5633-f624-41f8-abcf-043bc39a4bb7",
                        actionName: "Action info CNPJ",
                        params: { 
                            cnpj: nfInfo.notaFiscal[0]?.cnpjFilial?.replace(/\D/g, '') || "02823203000103"
                        } 
                    })
                    
                const infoResponse = response.data.data.data
                console.log('infoResponse >>> ', infoResponse)

                
                const match = infoResponse.telefone.match(/\((\d{2})\)\s*(\d{4,5}-\d{4})/);

                if (match) {
                    var ddd = match[1];     // "11"
                    var numero = match[2];  // "3218-6666"
                    
                    console.log("DDD:", ddd);
                    console.log("Número:", numero);
                }

                localRetirada = {
                    cpfCnpj: nfInfo.notaFiscal[0]?.cnpjFilial?.replace(/\D/g, ''),
                    razaoSocial: infoResponse.nome,
                    telefone: {
                        numero: numero?.replace(/\D/g, ''),
                        ddd: ddd
                    },
                    email: infoResponse.email,
                    endereco: {
                        descricaoCidade: infoResponse.municipio,
                        bairro: infoResponse.bairro,
                        cep: infoResponse.cep.replace(/\D/g, ''),
                        codigoCidade: "3550308",
                        numero: infoResponse.numero,
                        estado: infoResponse.uf,
                        logradouro: infoResponse.logradouro,
                        tipoLogradouro: "Rua"
                    }
                }
            }

            let transportadora
            if(nfInfo.notaFiscal[0]?.transportadora){
                const response = await Vue.prototype.$http.get(`/Entity/Fornecedor/${nfInfo.notaFiscal[0]?.transportadora}`)
                transportadora = response.data.data
            }

            if(fisPreDocEmiItem?.length > 0){
                await Vue.prototype.$http.get('/Entity/FisPreDocEmiItem/search-fields', {
                    params: {
                        ids: fisPreDocEmiItem.map(id => id).join(','),
                        sortField: 'sequencia'
                    }
                }).then((response) => {

                    response.data.data.data.map((item) => {
                        sum += item.valorTotal

                        const valorIbs = Number(
                            ((item.valorTotal / 100) * (this.ibs / 100)).toFixed(3)
                        )

                        const valorCbs = Number(
                            ((item.valorTotal / 100) * (this.cbs / 100)).toFixed(3)
                        )

                        const cstIcms = this.getCodigoTributario(item.ctsIcms, "00");
                        const cstPis = this.getCodigoTributario(item.ctsPis, "01");
                        const cstCofins = this.getCodigoTributario(item.ctsCofins, "01");
                        const icmsSemTributacao = ["40", "41", "50"].includes(cstIcms);
                        const pisIsento = cstPis === "07";
                        const cofinsIsento = cstCofins === "07";
                        const origemIcms = this.getCodigoTributario(item.icmsOrigem || item.origemMercadoria || item.origem, "0");
                        const percentualReducaoIcms = (() => {
                            const rawValue = item.icmsPercentualBaseCalculo;

                            if (rawValue === null || rawValue === undefined || String(rawValue).trim() === '') {
                                return undefined;
                            }

                            const normalizado = String(rawValue)
                                .trim()
                                .replace(/\./g, '')
                                .replace(',', '.');

                            const parsed = Number(normalizado);
                            return Number.isFinite(parsed) ? parsed : undefined;
                        })();

                        // Corta até o limite
                        let descricaoCortada = item?.descricao.substring(0, 120)

                        // Evita cortar palavra no meio
                        const ultimoEspaco = descricaoCortada.lastIndexOf(" ")

                        if (ultimoEspaco > 0) {
                            descricaoCortada = descricaoCortada.substring(0, ultimoEspaco)
                        }

                        const complemento = item?.descricao.substring(descricaoCortada.length).trim()
                        const ehVenda = !nfInfo.notaFiscalDeRemessa;
                        const valorBaseCalculoIcms = ehVenda
                            ? (item.icmsBaseCalculo != null && item.icmsBaseCalculo !== ''
                                ? item.icmsBaseCalculo / 100
                                : (item.resultBaseCalcICMS != null && item.resultBaseCalcICMS !== ''
                                    ? item.resultBaseCalcICMS / 100
                                    : undefined))
                            : (item.resultBaseCalcICMS != null && item.resultBaseCalcICMS !== ''
                                ? item.resultBaseCalcICMS / 100
                                : (item.icmsBaseCalculo != null && item.icmsBaseCalculo !== ''
                                    ? item.icmsBaseCalculo / 100
                                    : undefined))
                        const aliquotaIcms = Number(String(item.icmsPercentual ?? 0).replaceAll(',', '.'))
                        const enviarAliquotaIcms = !nfInfo.notaFiscalDeRemessa || exigirIcmsRemessa
                        const enviarBaseCalculoIcms = cstIcms !== "50" && (icmsSemTributacao
                            || nfInfo?.tipoNotaFiscal === "Nota_Fiscal"
                            || exigirIcmsRemessa)
                        const valorAliquotaIcms = cstIcms === "50"
                            ? undefined
                            : icmsSemTributacao
                            ? 0
                            : (enviarAliquotaIcms ? aliquotaIcms : undefined)
                        
                        const pedidoCompraItem = String(item?.sequenciaPedidoDeCompra ?? '').trim();
                        const numeroCompraItem = String(item?.pedidodecompra ?? '').trim();
                        const ncmItem = normalizePlugNotasNumericField(item?.ncm, nfInfo.notaFiscal[0]?.ncm)
                        const cestItem = normalizePlugNotasNumericField(item?.cest, nfInfo.notaFiscal[0]?.cest)

                        itens.push({
                            "codigo": item.codigo,
                            "descricao": this.removerAcentos(descricaoCortada),
                            "ncm": ncmItem || undefined,
                            "cest": cestItem || undefined,
                            "cfop": nfInfo.notaFiscal[0]?.cfop || "5101",
                            "valorFrete": item?.valorFrete / 100,
                            "valorDesconto": item?.valorDesconto / 100,
                            "valorOutros": item?.valorOutros / 100,
                            "valorSeguro": item?.valorSeguro / 100,
                            "informacoesComplementares": `${complemento} Itens conforme o romaneio ${romaneios.map((rm) => rm.codigo).join(' ')} Pedido de Compra: ${nfInfo.notaFiscal[0]?.project[0]?.pedidoCompra || ''}-${item?.observacao || ''}`?.replace(/\n/g, "") || undefined,
                            ...(pedidoCompraItem ? { "pedidoCompra": pedidoCompraItem } : {}),
                            ...(numeroCompraItem ? { "numeroCompra": numeroCompraItem } : {}),
                            "unidade": {
                                "comercial": item?.unidadeSigla || "PC",
                                "tributavel": item?.unidadeSigla || "PC"
                            },
                            "valorUnitario": {
                                "comercial": item.valorUnitario / 100,
                                "tributavel": item.valorUnitario / 100
                            },
                            "quantidade": {
                                "comercial": Number(item.quantidade.replaceAll(',', '.')),
                                "tributavel": Number(item.quantidade.replaceAll(',', '.'))
                            },
                            "valor": item.valorTotal / 100,
                            "codigoBeneficioFiscal": nfInfo.notaFiscal[0]?.codigoBeneficioFiscal || undefined,
                            "tributos": {
                                "ibscbs": !nfInfo.notaFiscalDeRemessa ? { // classificacaoIbsCbs
                                    "cst": item.cstIbsCbsCodigo,
                                    "classificacao": item.classificacaoIbsCbsCodigo,
                                    //"valorIbs": item.valorBaseCalculoIbsCbs / 100,
                                    "baseCalculo": item.valorBaseCalculoIbsCbs / 100,
                                    /*
                                    "municipio": {
                                        "aliquota": 0,
                                        "valor": 0
                                    },
                                    /*"uf": {
                                        "aliquota": item.aliquotaUf ? Number(item.aliquotaUf.replaceAll(',', '.')) : 0,
                                        "valor": item.valorUf ? item.valorUf / 100 : 0
                                    },
                                    "cbs": {
                                        "aliquota": 0, //Number(String(item.percentualBaseCalculoIbsCbs || 0).replaceAll(',', '.')) || 0,
                                        "valor": item.valorCbs ? item.valorCbs / 100 : 0
                                    },*/
                                } : undefined,
                                "icms": {
                                    "origem": origemIcms,
                                    "cst": cstIcms,
                                    "baseCalculo": enviarBaseCalculoIcms ?  {
                                        "modalidadeDeterminacao": 0,
                                        "valor": icmsSemTributacao ? 0 : valorBaseCalculoIcms,
                                        "percentualReducao": cstIcms === "20"
                                            ? (percentualReducaoIcms ?? 0)
                                            : undefined
                                    } : undefined,
                                    "aliquota": valorAliquotaIcms,
                                    "valor": (item.icmsValor && (nfInfo?.tipoNotaFiscal === "Nota_Fiscal" || nfInfo.notaFiscalDeRemessa)) ? item.icmsValor / 100 : undefined,
                                    "substituicaoTributaria": cstIcms == "10" || cstIcms == "70" ? {
                                        "aliquota": Number(item.aliqDestinoICMS?.replaceAll(',', '.')) || undefined,
                                        "baseCalculo": {
                                            "modalidadeDeterminacao": Number(item.modalidadeDeterminacao?.split(' - ')[0]) || 0,
                                            "valor": item.resultBaseCalcICMS / 100 || undefined
                                        }
                                    } : undefined
                                },
                                "pis": {
                                    "cst": cstPis,
                                    "baseCalculo": {
                                        "valor": pisIsento ? 0 : item.pisBaseCalculo / 100,
                                        "quantidade": 0
                                    },
                                    "aliquota": pisIsento ? 0 : Number(String(item.pisPercentual ?? 0).replaceAll(',', '.')) || 0,
                                    "valor": pisIsento ? 0 : Number(item.pisValor) / 100,
                                    //"aliquotaReais": 0,
                                    //"quantidadeVendida": 0
                                },
                                "cofins": {
                                    "cst": cstCofins,
                                    "baseCalculo": {
                                        "valor": cofinsIsento ? 0 : item.cofinsBaseCalculo / 100
                                    },
                                    "aliquota": cofinsIsento ? 0 : Number(String(item.cofinsPercentual ?? 0).replaceAll(',', '.')) || 0,
                                    "valor": cofinsIsento ? 0 : item.cofinsValor / 100
                                },
                                "ipi": {
                                    "cst": item?.ctsIpi?.split(" - ")[0] || "50",
                                    "baseCalculo": item.ipiBaseCalculo / 100,
                                    "valor": item.ipiValor / 100,
                                    "aliquota": Number(item?.ipiPercentual),
                                    "codigoEnquadramentoLegal": "103"
                                }
                            }
                        })
                    })
                })

                //console.log('fisPreDocEmiItem >>> ', itens)
            }

            const destinatarioInfoBase = nfInfo.notaFiscalDeRemessa
                ? nfInfo?.destinatarioInfoFornecedor?.[0]
                : nfInfo?.destinatarioInfo?.[0]

            const telefoneDestinatario = destinatarioInfoBase?.contatos?.[0]?.telefone?.replace(/\D/g, '')

            const dataBaseEmissao = moment(nfInfo.notaFiscal[0]?.dataEmissao || nfInfo.notaFiscal[0]?.createAt || new Date())
                .utcOffset(-3)
                .format('YYYY-MM-DDT00:00:00-03:00')

            const nfData =
                {
                    idIntegracao: `XXXYY${Math.floor(100000 + Math.random() * 900000)}`,
                    //transmitir: true,
                    dataEmissao: dataBaseEmissao,
                    presencial: "1",
                    consumidorFinal: true,
                    informacoesComplementares: 'NOSSO JOB ' + nfInfo.notaFiscal[0].project[0].code +  nfInfo?.notaFiscal[0]?.informacaoAdd?.replace(/\n/g, "") || '',
                    natureza: nfInfo.notaFiscal[0]?.naturezaOperacao || "OPERAÇÃO INTERNA",
                    notaReferenciada: nfInfo.notaFiscal[0]?.notaFiscalMae ? {
                        nfe: [ 
                            { chave: nfInfo.notaFiscal[0]?.notaFiscalMae }
                        ]
                    } : undefined,
                    emitente: {
                        cpfCnpj: nfInfo.notaFiscal[0]?.cnpjFilial?.replace(/\D/g, '') || "02823203000103",
                        inscricaoEstadual: "540036650111",
                        telefone: {
                            dd: '11',
                            numero: '32186666'
                        }
                    },
                    destinatario: {
                        cpfCnpj: nfInfo.notaFiscal[0]?.cnpj?.replace(/\D/g, ''),
                        razaoSocial: !nfInfo.notaFiscalDeRemessa ? nfInfo?.destinatarioNome : nfInfo?.destinatarioFornecedorNome,
                        email: nfInfo?.email || "contato@cliente.com.br",
                        inscricaoEstadual: destinatarioInfoBase?.inscricaoEstadual?.replace(/\D/g, '') || undefined,
                        telefone: {
                            dd: telefoneDestinatario ? telefoneDestinatario.slice(0, 2) : '11',
                            numero: telefoneDestinatario ? telefoneDestinatario.slice(2) : '999999999'
                        },
                        endereco: {
                            logradouro: nfInfo.notaFiscal[0]?.destinatarioLogradouro || destinatarioInfoBase?.cobrancaEndereco || "Logradouro não informado",
                            numero: nfInfo.notaFiscal[0]?.destinatarioNumero || destinatarioInfoBase?.cobrancaNumero || "S/N",
                            bairro: nfInfo.notaFiscal[0]?.destinatarioBairro || destinatarioInfoBase?.cobrancaBairro || "Bairro não informado",
                            codigoCidade: this.normalizeCodigoCidade(
                                nfInfo.notaFiscal[0]?.codigoCidade || "4115200",
                                nfInfo.notaFiscal[0]?.destinatarioCidade || destinatarioInfoBase?.cobrancaCidadeNome
                            ),
                            descricaoCidade: nfInfo.notaFiscal[0]?.destinatarioCidade || destinatarioInfoBase?.cobrancaCidadeNome || "Cidade não informada",
                            estado: nfInfo.notaFiscal[0]?.uf || "MG",
                            cep: nfInfo.notaFiscal[0]?.destinatarioCep?.replace(/\D/g, '') || destinatarioInfoBase?.cobrancaCEP?.replace(/\D/g, '') || "00000000"
                        }
                    },
                    itens: itens,
                    pagamentos: [
                        {
                            //tipo: nfInfo.notaFiscal[0].condicaoPagamento == 'á vista' ? "aVista" : nfInfo.notaFiscal[0].condicaoPagamento == 'á prazo' ? "aPrazo" : "",
                            aVista:  nfInfo.notaFiscal[0].condicaoPagamento == 'á vista' ? true : false,
                            meio: nfInfo.notaFiscal[0]?.meioPagamento?.replaceAll('_', ' ') ? this.getMeioPagamento(nfInfo.notaFiscal[0]?.meioPagamento?.replaceAll('_', ' ')) || 1 : 1,
                            valor: sum / 100,
                        }
                    ],
                    cobranca: nfInfo.notaFiscal[0].condicaoPagamento == 'á vista' ? undefined : {
                        numero: "12345",
                        valorLiquido: fisPreDocEmiFin.length > 0 ? valorLiquido : sum / 100,
                        valorTotal: fisPreDocEmiFin.length > 0 ? totalCobranca : sum / 100,
                        parcelas: fisPreDocEmiFin.length > 0 ? fisPreDocEmiFin.map((p) => {
                            return {
                                dataVencimento: new Date(p.dtPag),
                                numero: `00${p.parcelaSequencia}`,
                                tipoPagamento: 1,
                                valor: p.vlr / 100
                            }
                        }) : undefined
                    },
                    transporte: {
                        modalidadeFrete: this.mapTipoFreteToModalidadeFrete(romaneios[0]?.tipoFrete).toString(),
                        transportador: {
                            cnpj: transportadora?.cnpj?.replace(/\D/g, ''),
                            inscricaoEstadual: transportadora?.inscricaoEstadual?.replace(/\D/g, '') || undefined,
                            nome: transportadora?.nomeFantasia || transportadora?.razaoSocial,
                            endereco: {
                                logradouro: transportadora?.entregaEndereco,
                                descricaoCidade:  transportadora?.entregaCidadeNome,
                                uf: this.getSigla(transportadora?.entregaEstadoNome)
                            }
                        },
                        volumes: [
                            {
                                quantidade: Number(nfInfo.notaFiscal[0].volumeQuantidade),
                                especie: nfInfo.notaFiscal[0].especie,
                                marca: nfInfo.notaFiscal[0].marca,
                                numeracao: nfInfo.notaFiscal[0].volumeNumeracao,
                                pesoLiquido: Number(nfInfo.notaFiscal[0]?.pesoLiquido?.replace(',', '.')),
                                pesoBruto: Number(nfInfo.notaFiscal[0]?.pesoBruto?.replace(',', '.'))
                            }
                        ]
                    },
                    //imprimirLocalRetiradaEntrega: true,
                    localRetirada: isRetiradaAndEntrega ? localRetirada : undefined,
                    localEntrega: isRetiradaAndEntrega ? {
                        cpfCnpj: nfInfo.notaFiscal[0]?.cnpj?.replace(/\D/g, ''),
                        razaoSocial: !nfInfo.notaFiscalDeRemessa ? nfInfo?.destinatarioNome : nfInfo?.destinatarioFornecedorNome,
                        email: nfInfo?.email,
                        endereco: {
                            logradouro: nfInfo.notaFiscal[0]?.destinatarioLogradouro || destinatarioInfoBase?.cobrancaEndereco || "Logradouro não informado",
                            numero: nfInfo.notaFiscal[0]?.destinatarioNumero || destinatarioInfoBase?.cobrancaNumero || "S/N",
                            bairro: nfInfo.notaFiscal[0]?.destinatarioBairro || destinatarioInfoBase?.cobrancaBairro || "Bairro não informado",
                            codigoCidade: nfInfo.notaFiscal[0]?.codigoCidade || "3552205",
                            descricaoCidade: nfInfo.notaFiscal[0]?.destinatarioCidade || destinatarioInfoBase?.cobrancaCidadeNome || "Cidade não informada",
                            estado: nfInfo.notaFiscal[0]?.uf,
                            cep: nfInfo.notaFiscal[0]?.destinatarioCep?.replace(/\D/g, '') || destinatarioInfoBase?.cobrancaCEP?.replace(/\D/g, '') || "00000000"
                        }
                    } : undefined,
                    dataSaidaEntrada: dataBaseEmissao,
                }

            return nfData
        },


        getSigla(estado) {
            switch (estado) {
                case "Acre": return "AC";
                case "Alagoas": return "AL";
                case "Amapá": return "AP";
                case "Amazonas": return "AM";
                case "Bahia": return "BA";
                case "Ceará": return "CE";
                case "Distrito Federal": return "DF";
                case "Espírito Santo": return "ES";
                case "Goiás": return "GO";
                case "Maranhão": return "MA";
                case "Mato Grosso": return "MT";
                case "Mato Grosso do Sul": return "MS";
                case "Minas Gerais": return "MG";
                case "Pará": return "PA";
                case "Paraíba": return "PB";
                case "Paraná": return "PR";
                case "Pernambuco": return "PE";
                case "Piauí": return "PI";
                case "Rio de Janeiro": return "RJ";
                case "Rio Grande do Norte": return "RN";
                case "Rio Grande do Sul": return "RS";
                case "Rondônia": return "RO";
                case "Roraima": return "RR";
                case "Santa Catarina": return "SC";
                case "São Paulo": return "SP";
                case "Sergipe": return "SE";
                case "Tocantins": return "TO";
                default: return null; // caso não encontre
            }
        },

        removerAcentos(texto) {
            return texto
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/\s+/g, ' ')
                .trim()
        },
        

        mapTipoFreteToModalidadeFrete(tipoFrete) {
            if (!tipoFrete) throw new Error("tipoFrete não informado")

            // Extrai o código (primeira palavra)
            const codigo = tipoFrete.trim().substring(0, 3).toUpperCase()

            const vendedorPaga = ["CIF", "CFR", "CIP", "CPT", "DAP", "DPU", "DDP"]
            const compradorPaga = ["FOB", "EXW", "FCA", "FAS"]

            if (vendedorPaga.includes(codigo)) return 0
            if (compradorPaga.includes(codigo)) return 1

            throw new Error(`Incoterm inválido: ${codigo}`)
        },


        getMeioPagamento(meioPagamento){
            switch (meioPagamento) {
                case "Dinheiro":
                return "01"
                case "Cheque":
                return "02"
                case "Cartão de Crédito":
                return "03"
                case "Cartão de Débito":
                return "04"
                case "Cartão da Loja":
                return "05"
                case "Vale Alimentação":
                return "10"
                case "Vale Refeição":
                return "11"
                case "Vale Presente":
                return "12"
                case "Vale Combustível":
                return "13"
                case "Boleto Bancário":
                return "15"
                case "Depósito Bancário":
                return "16"
                case "Pagamento Instantâneo (PIX) - Dinâmico":
                return "17"
                case "Transferência bancária, Carteira Digital":
                return "18"
                case "Program de fidelidade, Cashback, Crédito Virtual":
                return "19"
                case "Pagamento Instantâneo (PIX) - Estático":
                return "20"
                case "Crédito em Loja":
                return "21"
                case "Pagamento Eletrônico não Informado - falha de hardware do sistema emissor":
                return "22"
                case "Sem pagamento":
                return "90"
                case "Pagamento Posterior":
                return "91"
                case "Outros":
                return "01"
                default:
                return "01"
            }
        },

        getNumberModFrete(modFrete){
            switch(modFrete){
                case 'Por conta do emitente':
                    return 0

                case 'Por conta do destinatário/remetente':
                    return 1

                case 'Por conta de terceiros':
                    return 2

                case 'Transporte Próprio por conta do Remetente':
                    return 3

                case 'Transporte Próprio por conta do Destinatário':
                    return 4

                case 'Sem frete':
                    return 5

                default:
                    return 0
            }
        },

        handleAlertCancel(nfInfo) {
            this.openAlertCancel = true
            this.itemNf = nfInfo
        },

        async confirmCancel(motivo){
            this.openAlertCancel = false

            if(this.itemNf.tipoNotaFiscal !== 'Nota_Fiscal_de_Serviço'){
                this.calcelNotaFiscal(this.itemNf, motivo)
            } else {
                this.cancelNotaFiscalServico(this.itemNf, motivo)
            }

            await this.getIssuanceInvoices()
        },

        async calcelNotaFiscal(infoNf, motivo) {
            console.log('nfInfo ', infoNf, JSON.parse(infoNf.plugNotasResponse))
            this.$notfy.warning("Cancelando Nota Fiscal...")

            const idIntegracao = infoNf.idIntegracao
            const idPlugNota = infoNf.plugNotasID

            try {
                const response = await axios.post(
                    `${this.baseUrl}/nfe/${idPlugNota}/cancelamento`,
                    {
                        "justificativa": motivo
                    },
                    {
                        headers: {
                            'X-API-KEY': this.apiKey,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                const objEmissao = await this.mergeEntityPayload('EmissaoNotasFiscais', infoNf?._id, {
                    plugNotasID: idPlugNota,
                    plugNotasMensagem: response.data?.message || "Cancelamento em processamento",
                    plugNotaIdIntegracao: idIntegracao,
                    tipoNotaFiscal: infoNf.tipoNotaFiscal.replaceAll('_', ' '),
                    destinatario: infoNf.destinatario,
                    statusNf: "Denegada",
                    chaveAcesso: response.data?.documents?.[0]?.chave || infoNf.chaveAcesso,
                    notaFiscalDeRemessa: infoNf.notaFiscalDeRemessa
                })

                const objFisPreDocEmi = await this.mergeEntityPayload('FisPreDocEmi', infoNf.notaFiscal[0]._id, {
                    statusEmissao: "CANCELADA",
                    plugNotasID: infoNf.plugNotasID,
                    plugNotasMensagem: response.data?.message || "Cancelamento em processamento",
                })

                const requisicoesCancelamento = [
                    Vue.prototype.$http.put('/Entity/EmissaoNotasFiscais', objEmissao),
                    Vue.prototype.$http.put('/Entity/FisPreDocEmi', objFisPreDocEmi),
                    this.atualizarStatusFisDocEmiPorInfo(infoNf, 'CANCELADA')
                ]

                await Promise.all(requisicoesCancelamento)

                // PUT explicito no FisDocEmi (fora do Promise.all) para garantir a execucao no fluxo de cancelamento.
                await this.forcarPutStatusFisDocEmiCancelada(infoNf, idPlugNota)

                console.log('NF cancelada com sucesso!', response.data);
                this.$notfy.success("Nota Fiscal Cancelada com sucesso.")

                // Consulta o resumo antes do refresh para manter numero/chave sincronizados
                await this.resumoNotaFiscal(infoNf, {
                    fallbackStatusNf: 'Denegada',
                    fallbackStatusPreNota: 'CANCELADA'
                })

                // Segundo PUT explicito apos consulta/resumo para assegurar consistencia final de status.
                await this.forcarPutStatusFisDocEmiCancelada(infoNf, idPlugNota)

                // Forca atualizacao do FisDocEmi apos refresh da tela, conforme regra solicitada.
                await this.getIssuanceInvoices()
                await this.atualizarStatusFisDocEmiPorInfo(infoNf, 'CANCELADA')
                await this.getIssuanceInvoices()
                

            } catch (error) {
                this.$notfy.error("Erro ao cancelar NF: ", error.response?.data || error.message)
                console.error('Erro ao cancelar NF:', error.response?.data || error.message);
            }
        },

        async cancelNotaFiscalServico(infoNf, motivo) {
            this.$notfy.warning("Cancelando Nota Fiscal de Serviço...")

            const idIntegracao = infoNf.plugNotaIdIntegracao
            const idPlugNota = infoNf.plugNotasID

                        /*
                                'https://api.plugnotas.com.br/nfse',
                    nfData,
                    {
                        headers: {
                            'X-API-KEY': '21c94f51-ca20-4ba0-a6d2-ffc23291680c',
                            'Content-Type': 'application/json'
                        }
                    }
            */

            try {
                const response = await axios.post(
                    `https://api.plugnotas.com.br/nfse/cancelar/${idPlugNota}`,
                    {
                        "codigo": idIntegracao,
                        "justificativa": motivo
                    },
                    {
                        headers: {
                            'X-API-KEY': this.apiKey,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                const objEmissao = await this.mergeEntityPayload('EmissaoNotasFiscais', infoNf._id, {
                    plugNotasID: infoNf.plugNotasID,
                    plugNotasMensagem: response.data?.message || "Cancelamento em processamento",
                    plugNotaIdIntegracao: infoNf.plugNotaIdIntegracao,
                    tipoNotaFiscal: infoNf.tipoNotaFiscal?.replaceAll('_', ' '),
                    destinatario: infoNf.destinatario,
                    destinatarioFornecedor: infoNf.destinatarioFornecedor || undefined,
                    statusNf: "Denegada",
                    chaveAcesso: response.data?.documents?.[0]?.chave || infoNf.chaveAcesso,
                    ncm: infoNf.ncm,
                    cest: infoNf.cest,
                    cfop: infoNf.cfop,
                    fisOper: infoNf.operacaoFiscal
                })

                const objFisDocService = await this.mergeEntityPayload('FisDocService', infoNf.notaFiscalServico[0]._id, {
                    status: "Cancelado",
                    plugNotasID: infoNf.plugNotasID,
                    plugNotasMensagem: response.data?.message || "Cancelamento em processamento"
                })

                await Promise.all([
                    Vue.prototype.$http.put('/Entity/EmissaoNotasFiscais', objEmissao),
                    Vue.prototype.$http.put('/Entity/FisDocService', objFisDocService)
                ])

                console.log('NF cancelada com sucesso!', response.data);
                this.$notfy.success("Nota Fiscal de Serviço Cancelada com sucesso.")
                
                // Recarrega a lista de notas fiscais
                await this.getIssuanceInvoices()

            } catch (error) {
                this.$notfy.error("Erro ao cancelar NF: ", error.response?.data || error.message)
                console.error('Erro ao cancelar NF:', error.response?.data || error.message);
            }
        }
    },
    async created(){
        await this.getIssuanceInvoices()

        console.log("TESTE >>> ", this.baseUrl, this.apiKey)
    }
}
</script>

<style scoped>
    .container {
        width: '100%'
    }

    .totalizadores-linha {
        margin-bottom: 12px;
    }

    .totalizador-card {
        height: 100%;
        padding: 16px 18px;
        border-radius: 10px;
        border-width: 1px;
        box-shadow: 0 6px 18px rgba(15, 23, 42, 0.26);
        transition: box-shadow 0.2s ease;
    }

    .totalizador-card:hover {
        box-shadow: 0 10px 24px rgba(15, 23, 42, 0.34);
    }

    .totalizador-card__titulo {
        color: rgba(0, 0, 0, 0.58);
        font-size: 0.85rem;
        font-weight: 600;
        margin-bottom: 8px;
        text-transform: uppercase;
    }

    .totalizador-card__valor {
        color: rgba(0, 0, 0, 0.87);
        font-size: 1.65rem;
        font-weight: 700;
        line-height: 1.2;
    }

    .totalizador-card--venda {
        background: #d7f2dd;
        border-color: #9bc8a5 !important;
    }

    .totalizador-card--venda .totalizador-card__valor {
        color: #146c43;
    }

    .totalizador-card--remessa {
        background: #f3f6ff;
        border-color: #c8d4ff !important;
    }

    .totalizador-card--remessa .totalizador-card__valor {
        color: #214a9f;
    }

    .totalizador-card--emitidas {
        background: #ece2fb;
        border-color: #cbb4f2 !important;
    }

    .totalizador-card--emitidas .totalizador-card__valor {
        color: #5d2c89;
    }

    .totalizador-card--canceladas {
        background: #f8dddd;
        border-color: #efb7b7 !important;
    }

    .totalizador-card--canceladas .totalizador-card__valor {
        color: #8f1e1e;
    }

    .search-form {
        gap: 10px;
        align-items: center;
    }

    .filtros-linha {
        gap: 12px;
    }

    .filtro-item {
        min-width: 180px;
        flex: 1 1 180px;
    }
</style>